import axios from "axios";
import {del, get, post, postFormData, put} from "./api_helper";
import * as url from "./url_helper";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { last } from "lodash";
import { use } from "i18next";
import { data } from "autoprefixer";

// Gets the logged in user data from local session
const getLoggedInUser = () => {
  const user = localStorage.getItem("user");
  if (user) return JSON.parse(user);
  return null;
};

//is user is logged in
const isUserAuthenticated = () => {
  return getLoggedInUser() !== null;
};

// Register Method
const postFakeRegister = data => post(url.BASE_URL + url.POST_FAKE_REGISTER, data);

// Login Method
const postFakeLogin = data => post(url.POST_FAKE_LOGIN, data);



// postForgetPwd
const postFakeForgetPwd = data => post(url.POST_FAKE_PASSWORD_FORGET, data);

// Edit profile
const postJwtProfile = data => post(url.POST_EDIT_JWT_PROFILE, data);

const postFakeProfile = data => post(url.POST_EDIT_PROFILE, data);

// Register Method
const postJwtRegister = (url, data) => {
  return axios
    .post(url, data)
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data;
      throw response.data;
    })
    .catch(err => {
      var message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found";
            break;
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team";
            break;
          case 401:
            message = "Invalid credentials";
            break;
          default:
            message = err[1];
            break;
        }
      }
      throw message;
    });
};

// Login Method
const postJwtLogin = data => post(url.BASE_URL + "/login", data);

export const postUpdateProfilePicture = data => postFormData(url.BASE_URL + url.POST_EDIT_PROFILE_PICTURE, data);

export const updateOrgLogoUrl = data => postFormData(url.BASE_URL + "/organization-logo",data)

export const postUpdateTwoFactorAuth = data => post(url.BASE_URL + "/enable-disable-two-factor-auth", data);

export const getServices = () => get(url.BASE_URL + "/service");

export const getAllowedDomainRestrictionsUrl = () => get(url.BASE_URL + "/organization/allowed-domains");

export const getIntegrationKeysUrl = (application_service_id) => get(url.BASE_URL + "/integration/app-integration?application_service_id=" + application_service_id);

export const getSpecificServiceUrl = data => get(url.BASE_URL + "/service/" + data);

export const createAndUpdateTagUrl = data => post(url.BASE_URL + "/tag-values",data);

export const getTagValuesByService = serviceId => get(`${url.BASE_URL}/tag-values/${serviceId}`);

export const softDeleteTagValue = data => put(url.BASE_URL + "/tag-values/delete", data);

export const getAllKeyNames = () => get(url.BASE_URL + "/tag-keys");

export const getIntegrationActionURLAPI = data => get(url.BASE_URL + "/integration/app-integration/" + data)

export const redirect_slack = () => get(url.BASE_URL + "/slack/install");

export const getTodos = () => get(url.BASE_URL + "/todolist");

export const getProfiles = () => get(url.BASE_URL + "/profile");

export const postAddService = data => post(url.BASE_URL + "/service", data);

export const postUpdateServiceUrl = data => post(url.BASE_URL + "/update-service", data);

export const postResendServiceEmailUrl = data => post(url.BASE_URL + "/resend-service-confirmation-email", data);

export const postCreateIntegrationKeyUrl = data => post(url.BASE_URL + "/integration/app-integration", data);

export const getTeams = () => get(url.BASE_URL + "/team");

export const postAddTeam = data => post(url.BASE_URL + "/team", data);

export const getCloudResources = data => get(url.BASE_URL + "/cloud-resource");

export const getGCPCloudResources = data => get(url.BASE_URL + "/gcp/resource");

export const getAzureCloudResourcesUrl = data => get(url.BASE_URL + "/azure/resource")

export const getNewRelicResourcesUrl = data => get(url.BASE_URL + "/newrelic/resource");

export const getDatadogResourcesUrl = data => get(url.BASE_URL + "/datadog/resource");

export const getSplunkResourcesUrl = data => get(url.BASE_URL + "/splunk/resource");

export const getMasterSystems = () => get(url.BASE_URL + "/master-system");

export const getMasterSystemsUrl = () => get(url.BASE_URL + "/master-system");

export const getMonitoringSystemsUrl = () => get(url.BASE_URL + "/monitoring-system");

export const getRefreshResources = () => get(url.BASE_URL + "/refresh-aws");

export const getRefreshGCPResources = () => get(url.BASE_URL + "/gcp/refresh");

export const getRefreshAzureResourcesUrl = () => get(url.BASE_URL + "/azure/refresh")

export const getNewRelicRefreshResourcesUrl = () => get(url.BASE_URL + "/newrelic/refresh-newrelic");

export const getDatadogRefreshResourcesUrl = () => get(url.BASE_URL + "/datadog/refresh-datadog");

export const getSplunkRefreshResourcesUrl = () => get(url.BASE_URL + "/splunk/refresh-splunk");

export const getOpsgenieRefreshUrl = data => post(url.BASE_URL + "/opsgenie/refresh", data);

export const getPagerdutyRefreshUrl = data => post(url.BASE_URL + "/pagerduty/refresh", data);

export const getMasterNotificationChannelsUrl = () => get(url.BASE_URL + "/master-notification-channel");

export const getGlobalThresholds = () => get(url.BASE_URL + "/default-thresholds");

export const postCloudOnboarding = data => post(url.BASE_URL + "/aws-onboarding", data);

export const postGCPOnboarding = data => post(url.BASE_URL + "/gcp/onboarding", data);

export const postAzureOnboardingUrl = data => post(url.BASE_URL+"/azure/onboarding", data);

export const postTestAWSConnectionUrl = data => post(url.BASE_URL + "/test-connection", data);

export const postTestGCPConnectionUrl = data => post(url.BASE_URL + "/gcp/test-connection", data);

export const postTestOCIConnectionUrl = data => post(url.BASE_URL + "/oci/test-connection", data);

export const postTestSentryConnectionUrl = data => post(url.BASE_URL + "/sentry/test-sentry-credentials", data);

export const postTestLokiConnectionUrl = data => post(url.BASE_URL + "/loki/test-loki-credentials", data);

export const postTestCoralogixConnectionUrl = data => post(url.BASE_URL + "/coralogix/test-coralogix-credentials", data);

export const postTestAzureConnectionUrl = data => post(url.BASE_URL+"/azure/test-connection", data);

export const postTestSignozConnectionUrl = data => post(url.BASE_URL + "/signoz/test-connection", data);

export const postOpsGenieOnboarding = data => post(url.BASE_URL + "/opsgenie-onboarding", data);

export const postPagerdutyOnboarding = data => post(url.BASE_URL + "/pagerduty-onboarding", data);

export const postEmailOnboarding = data => post(url.BASE_URL + "/email-onboarding", data);

export const getOpsGenieTeamsUrl = data => get(url.BASE_URL + "/opsgenie/teams");

export const getOpsGenieServicesUrl = () => get(url.BASE_URL + "/opsgenie/services");

export const getPagerdutyServicesUrl = data => get(url.BASE_URL + "/pagerduty/services");

export const postTestNotificationUrl = application_service_id => post(url.BASE_URL + "/integration/test-notification/" + application_service_id, {});

export const getMasterCommunicationChannelsUrl  = data => get(url.BASE_URL+"/master-communication-channels")
export const getBluejayCommunicationChannelByServiceIdUrl = data =>
  get(url.BASE_URL + "/bluejay-communication-channel-by-service?application_service_id=" + data)

export const updateBluejayCommunicationChannelByServiceIdUrl = data => post(url.BASE_URL+"/update-bluejay-communication-channel",data)
export const updatePagerdutyBluejayTeamUrl = data => post(url.BASE_URL + "/pagerduty/update-team", data);

export const getNewRelicAllResourceAlertsUrl = data => get(url.BASE_URL + "/newrelic/all-resource-alerts");

export const getAWSAllResourceAlertsUrl = data => get(url.BASE_URL + "/all-resource-alerts");

export const getAlcomScoreByServiceIdsUrl = data => post(url.BASE_URL + "/alcom-score-by-service-ids", data);

export const setMaintenanceWindowByServiceIdUrl = (data) => post(url.BASE_URL + `/set-service-maintenance`, data);

export const setOrgMaintenanceWindowUrl = (data) => post(url.BASE_URL + `/set-org-maintenance`, data);

export const postExternalPageDetailsUrl = data => post(url.BASE_URL + "/statuspage/get-external-page-subscribers", data);

export const createChangeEventWebhookUrl = data => post(url.BASE_URL + "/integration/organization-webhook", data);

export const getChangeEventWebhookUrl = data => get(url.BASE_URL + "/integration/organization-webhook");

export const oktaLoginUrl = data => get(url.BASE_URL +"/okta/login");

export const getMasterLoggingSystems = () => get(url.BASE_URL + "/master-logging-system");

export const getLoggingSystemsUrl = () => get(url.BASE_URL + "/logging-system");

export const getChangeEventsUrl = () => 
  get(url.BASE_URL + "/integration/change-event");

export const getChangeEventByIdUrl = (eventId) => 
  get(`${url.BASE_URL}/integration/change-event/${eventId}`);

export const getRecentChangeEventsUrl = data => get(url.BASE_URL + "/integration/recent-change-events?alert_log_id="+ data);

export const postCreateOktaSSOIntegrationUrl = data => post(url.BASE_URL + "/okta-integration", data);

export const getOktaSSOIntegrationUrl = () => get(url.BASE_URL + "/okta-integration");

export const getSentryProjects = () => get(url.BASE_URL + "/sentry/sentry-projects");

export const getLokiJobs = () => get(url.BASE_URL + "/loki/loki-jobs");

export const getCoralogixSubsystems = () => get(url.BASE_URL + "/coralogix/subsystems");

export const applyMappingConfigUrl = () => get(url.BASE_URL + "/apply-mapping-config");

export const createPaymentLinkUrl = data => post(url.BASE_URL + "/create-payment-link", data);

export const checkPaymentStatusUrl = data => post(url.BASE_URL + "/check-payment-status", data);

export const getAllAzureAccountsUrl = () => get(url.BASE_URL + "/azure/get-existing-account");

export const getAllGCPprojectsUrl = () => get(url.BASE_URL + "/gcp/gcp-projects");

export const getAWSAllResourceAlertsPageUrl = (data) => {
  let callURL = url.BASE_URL + "/all-resource-alerts-paginated?"
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.environments && data.environments.length > 0) {
    data.environments.map((item) => {
      callURL += "&environments=" + item;
    });
  }
  if (data.health_filter && data.health_filter.length > 0) {
    data.health_filter.map((item) => {
      callURL += "&health_filter=" + item;
    });
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }
  if (data.region && data.region.length > 0) {
    callURL += "&region=" + data.region;
  }

  if (data.eks_cluster_id) {
    callURL += "&eks_cluster_id=" + data.eks_cluster_id;
  }

  if (data.resource_types && data.resource_types.length > 0) {
    data.resource_types.map((item) => {
      callURL += "&resource_types=" + item;
    });
  }
  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.appsync_id) {
    callURL += "&appsync_id=" + data.appsync_id;
  }
  if (data.data_type){
    callURL += "&data_type=" + data.data_type;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }
  if ('account_ids' in data && data.account_ids.length > 0) {
    data.account_ids.map((item) => {
      callURL += "&account_ids=" + item;
    })
  }

  if ('application_service_ids' in data && data.application_service_ids.length > 0) {
    data.application_service_ids.map((item) => {
      callURL += "&application_service_ids=" + item;
    });
  } else if ('opsgenie_team_ids' in data && data.opsgenie_team_ids.length > 0) {
    data.opsgenie_team_ids.map((item) => {
      callURL += "&opsgenie_team_ids=" + item;
    })
  } else if ('pagerduty_service_ids' in data && data.pagerduty_service_ids.length > 0) {
    data.pagerduty_service_ids.map((item) => {
      callURL += "&pagerduty_service_ids=" + item;
    });

  }
  return get(callURL);
};

export const getAWSAllResourceCountPageUrl = (data) => {
  let callURL = url.BASE_URL + "/get_resource_count?"
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.environments && data.environments.length > 0) {
    data.environments.map((item) => {
      callURL += "&environments=" + item;
    });
  }
  if (data.health_filter && data.health_filter.length > 0) {
    data.health_filter.map((item) => {
      callURL += "&health_filter=" + item;
    });
  }
  if ('account_ids' in data && data.account_ids.length > 0) {
    data.account_ids.map((item) => {
      callURL += "&account_ids=" + item;
    })
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }
  if (data.region && data.region.length > 0) {
    callURL += "&region=" + data.region;
  }

  if (data.appsync_id) {
    callURL += "&appsync_id=" + data.appsync_id;
  }
  if (data.data_type){
    callURL += "&data_type=" + data.data_type;
  }

  if (data.eks_cluster_id) {
    callURL += "&eks_cluster_id=" + data.eks_cluster_id;
  }

  if (data.resource_types && data.resource_types.length > 0) {
    data.resource_types.map((item) => {
      callURL += "&resource_types=" + item;
    });
  }
  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }
  if ('application_service_ids' in data && data.application_service_ids.length > 0) {
    data.application_service_ids.map((item) => {
      callURL += "&application_service_ids=" + item;
    });
  } else if ('opsgenie_team_ids' in data && data.opsgenie_team_ids.length > 0) {
    data.opsgenie_team_ids.map((item) => {
      callURL += "&opsgenie_team_ids=" + item;
    })
  } else if ('pagerduty_service_ids' in data && data.pagerduty_service_ids.length > 0) {
    data.pagerduty_service_ids.map((item) => {
      callURL += "&pagerduty_service_ids=" + item;
    });
  }
  return get(callURL);
};

export const getGCPAllResourceAlertsPageUrl = (data) => {
  let callURL = url.BASE_URL + "/gcp/all-resource-alerts-paginated?"
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.environments && data.environments.length > 0) {
    data.environments.map((item) => {
      callURL += "&environments=" + item;
    });
  }
  if (data.health_filter && data.health_filter.length > 0) {
    data.health_filter.map((item) => {
      callURL += "&health_filter=" + item;
    });
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }
  if (data.region && data.region.length > 0) {
    callURL += "&region=" + data.region;
  }

  if (data.resource_types && data.resource_types.length > 0) {
    data.resource_types.map((item) => {
      callURL += "&resource_types=" + item;
    });
  }
  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }
  if ('application_service_ids' in data && data.application_service_ids.length > 0) {
    data.application_service_ids.map((item) => {
      callURL += "&application_service_ids=" + item;
    });
  } else if ('opsgenie_team_ids' in data && data.opsgenie_team_ids.length > 0) {
    data.opsgenie_team_ids.map((item) => {
      callURL += "&opsgenie_team_ids=" + item;
    })
  } else if ('pagerduty_service_ids' in data && data.pagerduty_service_ids.length > 0) {
    data.pagerduty_service_ids.map((item) => {
      callURL += "&pagerduty_service_ids=" + item;
    });
  }
  return get(callURL);
};

export const getGCPAllResourceCountPageUrl = (data) => {
  let callURL = url.BASE_URL + "/gcp/get_resource_count?"
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.environments && data.environments.length > 0) {
    data.environments.map((item) => {
      callURL += "&environments=" + item;
    });
  }
  if (data.health_filter && data.health_filter.length > 0) {
    data.health_filter.map((item) => {
      callURL += "&health_filter=" + item;
    });
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }
  if (data.region && data.region.length > 0) {
    callURL += "&region=" + data.region;
  }

  if (data.resource_types && data.resource_types.length > 0) {
    data.resource_types.map((item) => {
      callURL += "&resource_types=" + item;
    });
  }
  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }
  if ('application_service_ids' in data && data.application_service_ids.length > 0) {
    data.application_service_ids.map((item) => {
      callURL += "&application_service_ids=" + item;
    });
  } else if ('opsgenie_team_ids' in data && data.opsgenie_team_ids.length > 0) {
    data.opsgenie_team_ids.map((item) => {
      callURL += "&opsgenie_team_ids=" + item;
    })
  } else if ('pagerduty_service_ids' in data && data.pagerduty_service_ids.length > 0) {
    data.pagerduty_service_ids.map((item) => {
      callURL += "&pagerduty_service_ids=" + item;
    });
  }
  return get(callURL);
};

//azure
export const getAzureAllResourceAlertsPageUrl = (data) => {
  let callURL = url.BASE_URL + "/azure/all-resource-alerts-paginated?"
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.environments && data.environments.length > 0) {
    data.environments.map((item) => {
      callURL += "&environments=" + item;
    });
  }
  if (data.health_filter && data.health_filter.length > 0) {
    data.health_filter.map((item) => {
      callURL += "&health_filter=" + item;
    });
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }
  if (data.region && data.region.length > 0) {
    callURL += "&region=" + data.region;
  }

  if (data.resource_types && data.resource_types.length > 0) {
    data.resource_types.map((item) => {
      callURL += "&resource_types=" + item;
    });
  }
  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }
  if ('application_service_ids' in data && data.application_service_ids.length > 0) {
    data.application_service_ids.map((item) => {
      callURL += "&application_service_ids=" + item;
    });
  } else if ('opsgenie_team_ids' in data && data.opsgenie_team_ids.length > 0) {
    data.opsgenie_team_ids.map((item) => {
      callURL += "&opsgenie_team_ids=" + item;
    })
  } else if ('pagerduty_service_ids' in data && data.pagerduty_service_ids.length > 0) {
    data.pagerduty_service_ids.map((item) => {
      callURL += "&pagerduty_service_ids=" + item;
    });
  }
  return get(callURL);
};

export const getAzureAllResourceAlertsCountPageUrl = (data) => {
  let callURL = url.BASE_URL + "/azure/get-resource-count?"
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.environments && data.environments.length > 0) {
    data.environments.map((item) => {
      callURL += "&environments=" + item;
    });
  }
  if (data.health_filter && data.health_filter.length > 0) {
    data.health_filter.map((item) => {
      callURL += "&health_filter=" + item;
    });
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }
  if (data.region && data.region.length > 0) {
    callURL += "&region=" + data.region;
  }

  if (data.resource_types && data.resource_types.length > 0) {
    data.resource_types.map((item) => {
      callURL += "&resource_types=" + item;
    });
  }
  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }
  if ('application_service_ids' in data && data.application_service_ids.length > 0) {
    data.application_service_ids.map((item) => {
      callURL += "&application_service_ids=" + item;
    });
  } else if ('opsgenie_team_ids' in data && data.opsgenie_team_ids.length > 0) {
    data.opsgenie_team_ids.map((item) => {
      callURL += "&opsgenie_team_ids=" + item;
    })
  } else if ('pagerduty_service_ids' in data && data.pagerduty_service_ids.length > 0) {
    data.pagerduty_service_ids.map((item) => {
      callURL += "&pagerduty_service_ids=" + item;
    });
  }
  return get(callURL);
};

export const getNewRelicAllExternalServicesResourceAlertsPageUrl = (data) => {
  let callURL = url.BASE_URL + "/newrelic/all-external-services-resource-alerts-paginated?"
  if (data.page) {
    callURL += "page=" + data.page;
  }

  if (data.service_monitored_resource_id){
    callURL += "&service_monitored_resource_id=" + data.service_monitored_resource_id;
  }

  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.environments && data.environments.length > 0) {
    data.environments.map((item) => {
      callURL += "&environments=" + item;
    });
  }
  if (data.health_filter && data.health_filter.length > 0) {
    data.health_filter.map((item) => {
      callURL += "&health_filter=" + item;
    });
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }

  if (data.resource_types && data.resource_types.length > 0) {
    data.resource_types.map((item) => {
      callURL += "&resource_types=" + item;
    });
  }
  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }
  if ('application_service_ids' in data && data.application_service_ids.length > 0) {
    data.application_service_ids.map((item) => {
      callURL += "&application_service_ids=" + item;
    });
  } else if ('opsgenie_team_ids' in data && data.opsgenie_team_ids.length > 0) {
    data.opsgenie_team_ids.map((item) => {
      callURL += "&opsgenie_team_ids=" + item;
    })
  } else if ('pagerduty_service_ids' in data && data.pagerduty_service_ids.length > 0) {
    data.pagerduty_service_ids.map((item) => {
      callURL += "&pagerduty_service_ids=" + item;
    });
  }
  return get(callURL);
};

export const getNewRelicAllExternalServicesResourceCountUrl = (data) => {
  let callURL = url.BASE_URL + "/newrelic/get_external_services_resource_count?"
  if (data.page) {
    callURL += "page=" + data.page;
  }

  if (data.service_monitored_resource_id){
    callURL += "&service_monitored_resource_id=" + data.service_monitored_resource_id;
  }

  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.environments && data.environments.length > 0) {
    data.environments.map((item) => {
      callURL += "&environments=" + item;
    });
  }
  if (data.health_filter && data.health_filter.length > 0) {
    data.health_filter.map((item) => {
      callURL += "&health_filter=" + item;
    });
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }

  if (data.resource_types && data.resource_types.length > 0) {
    data.resource_types.map((item) => {
      callURL += "&resource_types=" + item;
    });
  }
  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }
  if ('application_service_ids' in data && data.application_service_ids.length > 0) {
    data.application_service_ids.map((item) => {
      callURL += "&application_service_ids=" + item;
    });
  } else if ('opsgenie_team_ids' in data && data.opsgenie_team_ids.length > 0) {
    data.opsgenie_team_ids.map((item) => {
      callURL += "&opsgenie_team_ids=" + item;
    })
  } else if ('pagerduty_service_ids' in data && data.pagerduty_service_ids.length > 0) {
    data.pagerduty_service_ids.map((item) => {
      callURL += "&pagerduty_service_ids=" + item;
    });
  }
  return get(callURL);
};

export const getNewRelicAllResourceAlertsPageUrl = (data) => {
  let callURL = url.BASE_URL + "/newrelic/all-resource-alerts-paginated?"
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.environments && data.environments.length > 0) {
    data.environments.map((item) => {
      callURL += "&environments=" + item;
    });
  }
  if (data.health_filter && data.health_filter.length > 0) {
    data.health_filter.map((item) => {
      callURL += "&health_filter=" + item;
    });
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }

  if (data.resource_types && data.resource_types.length > 0) {
    data.resource_types.map((item) => {
      callURL += "&resource_types=" + item;
    });
  }
  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }
  if ('application_service_ids' in data && data.application_service_ids.length > 0) {
    data.application_service_ids.map((item) => {
      callURL += "&application_service_ids=" + item;
    });
  } else if ('opsgenie_team_ids' in data && data.opsgenie_team_ids.length > 0) {
    data.opsgenie_team_ids.map((item) => {
      callURL += "&opsgenie_team_ids=" + item;
    })
  } else if ('pagerduty_service_ids' in data && data.pagerduty_service_ids.length > 0) {
    data.pagerduty_service_ids.map((item) => {
      callURL += "&pagerduty_service_ids=" + item;
    });
  }
  return get(callURL);
};

export const getSplunkAllResourceAlertsPageUrl = (data) => {
  let callURL = url.BASE_URL + "/splunk/all-resource-alerts-paginated?"
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.environments && data.environments.length > 0) {
    data.environments.map((item) => {
      callURL += "&environments=" + item;
    });
  }
  if (data.health_filter && data.health_filter.length > 0) {
    data.health_filter.map((item) => {
      callURL += "&health_filter=" + item;
    });
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }

  if (data.resource_types && data.resource_types.length > 0) {
    data.resource_types.map((item) => {
      callURL += "&resource_types=" + item;
    });
  }
  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }
  if ('application_service_ids' in data && data.application_service_ids.length > 0) {
    data.application_service_ids.map((item) => {
      callURL += "&application_service_ids=" + item;
    });
  } else if ('opsgenie_team_ids' in data && data.opsgenie_team_ids.length > 0) {
    data.opsgenie_team_ids.map((item) => {
      callURL += "&opsgenie_team_ids=" + item;
    })
  } else if ('pagerduty_service_ids' in data && data.pagerduty_service_ids.length > 0) {
    data.pagerduty_service_ids.map((item) => {
      callURL += "&pagerduty_service_ids=" + item;
    });
  }
  return get(callURL);
};

export const getDatadogAllResourceAlertsPageUrl = (data) => {
  let callURL = url.BASE_URL + "/datadog/all-resource-alerts-paginated?"
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.environments && data.environments.length > 0) {
    data.environments.map((item) => {
      callURL += "&environments=" + item;
    });
  }
  if (data.health_filter && data.health_filter.length > 0) {
    data.health_filter.map((item) => {
      callURL += "&health_filter=" + item;
    });
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }

  if (data.resource_types && data.resource_types.length > 0) {
    data.resource_types.map((item) => {
      callURL += "&resource_types=" + item;
    });
  }
  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }
  if ('application_service_ids' in data && data.application_service_ids.length > 0) {
    data.application_service_ids.map((item) => {
      callURL += "&application_service_ids=" + item;
    });
  } else if ('opsgenie_team_ids' in data && data.opsgenie_team_ids.length > 0) {
    data.opsgenie_team_ids.map((item) => {
      callURL += "&opsgenie_team_ids=" + item;
    })
  } else if ('pagerduty_service_ids' in data && data.pagerduty_service_ids.length > 0) {
    data.pagerduty_service_ids.map((item) => {
      callURL += "&pagerduty_service_ids=" + item;
    });
  }
  return get(callURL);
};

export const getSplunkAllServiceDependencyResourceAlertsPageUrl = (data) => {
  let callURL = url.BASE_URL + "/splunk/all-service-dependencies-resource-alerts-paginated?"
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.environments && data.environments.length > 0) {
    data.environments.map((item) => {
      callURL += "&environments=" + item;
    });
  }
  if (data.health_filter && data.health_filter.length > 0) {
    data.health_filter.map((item) => {
      callURL += "&health_filter=" + item;
    });
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }

  if (data.resource_types && data.resource_types.length > 0) {
    data.resource_types.map((item) => {
      callURL += "&resource_types=" + item;
    });
  }
  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }
  if ('application_service_ids' in data && data.application_service_ids.length > 0) {
    data.application_service_ids.map((item) => {
      callURL += "&application_service_ids=" + item;
    });
  } else if ('opsgenie_team_ids' in data && data.opsgenie_team_ids.length > 0) {
    data.opsgenie_team_ids.map((item) => {
      callURL += "&opsgenie_team_ids=" + item;
    })
  } else if ('pagerduty_service_ids' in data && data.pagerduty_service_ids.length > 0) {
    data.pagerduty_service_ids.map((item) => {
      callURL += "&pagerduty_service_ids=" + item;
    });
  }

  if ('service_monitored_resource_id' in data && data.service_monitored_resource_id) {
    callURL += "&service_monitored_resource_id=" + data.service_monitored_resource_id;
  }

  if ('service_type' in data && data.service_type) {
    callURL += "&service_type=" + data.service_type;
  }

  return get(callURL);
};

export const getDatadogAllServiceDependencyResourceAlertsPageUrl = (data) => {
  let callURL = url.BASE_URL + "/datadog/all-service-dependencies-resource-alerts-paginated?"
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.environments && data.environments.length > 0) {
    data.environments.map((item) => {
      callURL += "&environments=" + item;
    });
  }
  if (data.health_filter && data.health_filter.length > 0) {
    data.health_filter.map((item) => {
      callURL += "&health_filter=" + item;
    });
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }

  if (data.resource_types && data.resource_types.length > 0) {
    data.resource_types.map((item) => {
      callURL += "&resource_types=" + item;
    });
  }
  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }
  if ('application_service_ids' in data && data.application_service_ids.length > 0) {
    data.application_service_ids.map((item) => {
      callURL += "&application_service_ids=" + item;
    });
  } else if ('opsgenie_team_ids' in data && data.opsgenie_team_ids.length > 0) {
    data.opsgenie_team_ids.map((item) => {
      callURL += "&opsgenie_team_ids=" + item;
    })
  } else if ('pagerduty_service_ids' in data && data.pagerduty_service_ids.length > 0) {
    data.pagerduty_service_ids.map((item) => {
      callURL += "&pagerduty_service_ids=" + item;
    });
  }

  if ('service_monitored_resource_id' in data && data.service_monitored_resource_id) {
    callURL += "&service_monitored_resource_id=" + data.service_monitored_resource_id;
  }
  return get(callURL);
};

export const getNewRelicAllResourceCountUrl = (data) => {
  let callURL = url.BASE_URL + "/newrelic/get_resource_count?"
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.environments && data.environments.length > 0) {
    data.environments.map((item) => {
      callURL += "&environments=" + item;
    });
  }
  if (data.health_filter && data.health_filter.length > 0) {
    data.health_filter.map((item) => {
      callURL += "&health_filter=" + item;
    });
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }

  if (data.resource_types && data.resource_types.length > 0) {
    data.resource_types.map((item) => {
      callURL += "&resource_types=" + item;
    });
  }
  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }
  if ('application_service_ids' in data && data.application_service_ids.length > 0) {
    data.application_service_ids.map((item) => {
      callURL += "&application_service_ids=" + item;
    });
  } else if ('opsgenie_team_ids' in data && data.opsgenie_team_ids.length > 0) {
    data.opsgenie_team_ids.map((item) => {
      callURL += "&opsgenie_team_ids=" + item;
    })
  } else if ('pagerduty_service_ids' in data && data.pagerduty_service_ids.length > 0) {
    data.pagerduty_service_ids.map((item) => {
      callURL += "&pagerduty_service_ids=" + item;
    });
  }
  return get(callURL);
};


export const getSplunkAllResourceCountUrl = (data) => {
  let callURL = url.BASE_URL + "/splunk/get_resource_count?"
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.environments && data.environments.length > 0) {
    data.environments.map((item) => {
      callURL += "&environments=" + item;
    });
  }
  if (data.health_filter && data.health_filter.length > 0) {
    data.health_filter.map((item) => {
      callURL += "&health_filter=" + item;
    });
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }

  if (data.resource_types && data.resource_types.length > 0) {
    data.resource_types.map((item) => {
      callURL += "&resource_types=" + item;
    });
  }
  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }
  if ('application_service_ids' in data && data.application_service_ids.length > 0) {
    data.application_service_ids.map((item) => {
      callURL += "&application_service_ids=" + item;
    });
  } else if ('opsgenie_team_ids' in data && data.opsgenie_team_ids.length > 0) {
    data.opsgenie_team_ids.map((item) => {
      callURL += "&opsgenie_team_ids=" + item;
    })
  } else if ('pagerduty_service_ids' in data && data.pagerduty_service_ids.length > 0) {
    data.pagerduty_service_ids.map((item) => {
      callURL += "&pagerduty_service_ids=" + item;
    });
  }
  return get(callURL);
};


export const getDatadogAllResourceCountUrl = (data) => {
  let callURL = url.BASE_URL + "/datadog/get_resource_count?"
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.environments && data.environments.length > 0) {
    data.environments.map((item) => {
      callURL += "&environments=" + item;
    });
  }
  if (data.health_filter && data.health_filter.length > 0) {
    data.health_filter.map((item) => {
      callURL += "&health_filter=" + item;
    });
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }

  if (data.resource_types && data.resource_types.length > 0) {
    data.resource_types.map((item) => {
      callURL += "&resource_types=" + item;
    });
  }
  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }
  if ('application_service_ids' in data && data.application_service_ids.length > 0) {
    data.application_service_ids.map((item) => {
      callURL += "&application_service_ids=" + item;
    });
  } else if ('opsgenie_team_ids' in data && data.opsgenie_team_ids.length > 0) {
    data.opsgenie_team_ids.map((item) => {
      callURL += "&opsgenie_team_ids=" + item;
    })
  } else if ('pagerduty_service_ids' in data && data.pagerduty_service_ids.length > 0) {
    data.pagerduty_service_ids.map((item) => {
      callURL += "&pagerduty_service_ids=" + item;
    });
  }
  return get(callURL);
};

export const getSplunkAllServiceDependencyResourceCountUrl = (data) => {
  let callURL = url.BASE_URL + "/splunk/get_service_dependencies_resource_count?"
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.environments && data.environments.length > 0) {
    data.environments.map((item) => {
      callURL += "&environments=" + item;
    });
  }
  if (data.health_filter && data.health_filter.length > 0) {
    data.health_filter.map((item) => {
      callURL += "&health_filter=" + item;
    });
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }

  if (data.resource_types && data.resource_types.length > 0) {
    data.resource_types.map((item) => {
      callURL += "&resource_types=" + item;
    });
  }
  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }
  if ('application_service_ids' in data && data.application_service_ids.length > 0) {
    data.application_service_ids.map((item) => {
      callURL += "&application_service_ids=" + item;
    });
  } else if ('opsgenie_team_ids' in data && data.opsgenie_team_ids.length > 0) {
    data.opsgenie_team_ids.map((item) => {
      callURL += "&opsgenie_team_ids=" + item;
    })
  } else if ('pagerduty_service_ids' in data && data.pagerduty_service_ids.length > 0) {
    data.pagerduty_service_ids.map((item) => {
      callURL += "&pagerduty_service_ids=" + item;
    });
  }

  if ('service_monitored_resource_id' in data && data.service_monitored_resource_id) {
    callURL += "&service_monitored_resource_id=" + data.service_monitored_resource_id;
  }

  if ('service_type' in data && data.service_type) {
    callURL += "&service_type=" + data.service_type;
  }

  return get(callURL);
};


export const getDatadogAllServiceDependencyResourceCountUrl = (data) => {
  let callURL = url.BASE_URL + "/datadog/get_service_dependencies_resource_count?"
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.environments && data.environments.length > 0) {
    data.environments.map((item) => {
      callURL += "&environments=" + item;
    });
  }
  if (data.health_filter && data.health_filter.length > 0) {
    data.health_filter.map((item) => {
      callURL += "&health_filter=" + item;
    });
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }

  if (data.resource_types && data.resource_types.length > 0) {
    data.resource_types.map((item) => {
      callURL += "&resource_types=" + item;
    });
  }
  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }
  if ('application_service_ids' in data && data.application_service_ids.length > 0) {
    data.application_service_ids.map((item) => {
      callURL += "&application_service_ids=" + item;
    });
  } else if ('opsgenie_team_ids' in data && data.opsgenie_team_ids.length > 0) {
    data.opsgenie_team_ids.map((item) => {
      callURL += "&opsgenie_team_ids=" + item;
    })
  } else if ('pagerduty_service_ids' in data && data.pagerduty_service_ids.length > 0) {
    data.pagerduty_service_ids.map((item) => {
      callURL += "&pagerduty_service_ids=" + item;
    });
  }

  if ('service_monitored_resource_id' in data && data.service_monitored_resource_id) {
    callURL += "&service_monitored_resource_id=" + data.service_monitored_resource_id;
  }

  return get(callURL);
};

export const getTransactionsByAPMUrl = (data) => {
  let callURL = url.BASE_URL + "/newrelic/all-transactions-by-apm-paginated?";
  callURL += "apm_monitored_resource_id=" + data.apm_monitored_resource_id;

  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.page) {
    callURL += "&page=" + data.page
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }
  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }

  return get(callURL);
}

export const getApiEndpointsByAPMUrl = (data) => {
  let callURL = url.BASE_URL + "/datadog/all-api-endpoints-by-apm-paginated?";
  callURL += "apm_monitored_resource_id=" + data.apm_monitored_resource_id;

  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.page) {
    callURL += "&page=" + data.page
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }
  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }

  return get(callURL);
}

export const getAlertLogsUrl = (data) => {
  let callURL = url.BASE_URL + "/alert-manager/alerts?"
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&limit=" + data.limit;
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }
  if ('application_service_ids' in data && data.application_service_ids.length > 0) {
    data.application_service_ids.map((item) => {
      callURL += "&application_service_ids=" + item;
    });
  }
  if ('status_list' in data && data.status_list.length > 0) {
    data.status_list.map((item) => {
      callURL += "&status_list=" + item;
    });
  }
  if('source_types' in data && data.source_types.length > 0){
    data.source_types.map((item) => {
      callURL += "&source_types=" + item;
    })
  }
  if ('assigned_to' in data && data.assigned_to.length > 0) {
    data.assigned_to.map((item) => {
      callURL += "&assigned_to=" + item;
    });
  }
  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }
  if (data.integration_type) {
    callURL += "&integration_type=" + data.integration_type;
  }
  return get(callURL);
};

export const getAlertLogsCountUrl = (data) => {
  let callURL = url.BASE_URL + "/alert-manager/get-alertlog-count?"
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&limit=" + data.limit;
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }
  if ('application_service_ids' in data && data.application_service_ids.length > 0) {
    data.application_service_ids.map((item) => {
      callURL += "&application_service_ids=" + item;
    });
  }
  if ('status_list' in data && data.status_list.length > 0) {
    data.status_list.map((item) => {
      callURL += "&status_list=" + item;
    });
  }
  if ('assigned_to' in data && data.assigned_to.length > 0) {
    data.assigned_to.map((item) => {
      callURL += "&assigned_to=" + item;
    });
  }

  if('source_types' in data && data.source_types.length > 0){
    data.source_types.map((item) => {
      callURL += "&source_types=" + item;
    })
  }

  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }
  if (data.integration_type) {
    callURL += "&integration_type=" + data.integration_type;
  }
  return get(callURL);
};

export const getIntegrationTypesUrl = () => get(url.BASE_URL + "/integration-types");

export const getRunbookResultsUrl = (alert_log_id) => get(url.BASE_URL + "/alert-manager/diagnostic-recovery-steps-results?alert_log_id=" + alert_log_id);

export const getUserExecutedResultsUrl = (alert_log_id) => get(url.BASE_URL + "/daemon-manager/user-execution-history?alert_log_id=" + alert_log_id);

export const getRunbookUrl = (alert_id) => get(url.BASE_URL + "/ai/runbook-by-alertlog-id/" + alert_id);

export const getRunbookDetailsUrl = (runbook_id) => get(url.BASE_URL + "/ai/runbook/" + runbook_id);

export const postRunbookFeedbackUrl = data => post(url.BASE_URL + "/ai/runbook-feedback", data);

export const getRunbookFeedbacksUrl = (runbook_id) => get(url.BASE_URL + "/ai/runbook-feedback/" + runbook_id)

export const postRunbookUrl = data => post(url.BASE_URL + "/ai/runbook", data);

export const executeRunbookStepUrl = data => post(url.BASE_URL + "/daemon-manager/execute-runbook", data);

export const startAiConversationUrl = (data) => post(url.BASE_URL + "/ai/vibe-debugging", data);

export const updateRunbookUrl = (data, id) => post(url.BASE_URL + `/ai/runbook/${id}`, data);

export const getAlertCorrelationUrl = (alert_id) => get(url.BASE_URL + "/ai/get-correlated-alerts-by-alert-log-id?alert_log_id=" + alert_id);

export const getErrorLogsUrl = (alert_id) => get(url.BASE_URL + "/alert-manager/error-logs-by-alert-log-id?alert_log_id=" + alert_id);

export const getAlertLogStatusHistoryUrl = (alert_log_id) => get(url.BASE_URL + "/alert-manager/alert-log-status?alert_log_id=" + alert_log_id);

export const getSuggestedMappingsUrl = () => get(url.BASE_URL + `/ai/mapping/get-mapping`);

export const getPastAiConversationsUrl = (alert_log_id) => get(url.BASE_URL + `/ai/conversation?alert_log_id=` + alert_log_id);

export const getCheckAiAvailabilityUrl = (alert_log_id) => get(url.BASE_URL + `/ai/agent-availability?alert_log_id=` + alert_log_id);

export const updateSuggestedMappingsUrl = (data) => post(url.BASE_URL + `/ai/mapping/update-suggestion`, data);

export const getAlertLogDetailsUrl = (alert_id) => get(url.BASE_URL + "/alert-manager/alert/" + alert_id);

export const getMetricDataUrl = (alert_id) => get(url.BASE_URL + "/alert-manager/get-correlated_metrics_data?alert_log_id=" + alert_id);

export const postAcknowledgeAlertUrl = data => post(url.BASE_URL + "/alert-manager/ack-alerts", data);

export const postResolveAlertUrl = data => post(url.BASE_URL + "/alert-manager/resolve-alerts", data);

export const getAllOrgAWSResourceTypesUrl = () => get(url.BASE_URL + "/org-aws-resource-types");

export const getAllOrgGCPResourceTypesUrl = () => get(url.BASE_URL + "/gcp/org-resource-types");

export const getAllOrgAzureResourceTypesUrl = () => get(url.BASE_URL + "/azure/org-resource-types");

export const getAllOrgNewRelicResourceTypesUrl = () => get(url.BASE_URL + "/newrelic/org-resource-types");

export const getAllOrgDatadogResourceTypesUrl = () => get(url.BASE_URL + "/datadog/org-resource-types");

export const getAllOrgSplunkResourceTypesUrl = () => get(url.BASE_URL + "/splunk/org-resource-types");

export const postOnCallPolicyUrl = data => post(url.BASE_URL + "/oncall/oncall-policy", data);

export const getOnCallPolicyUrl = () => get(url.BASE_URL + "/oncall/oncall-policy");

export const getSpecificOnCallPolicyUrl = data => get(url.BASE_URL + "/oncall/oncall-policy/" + data);

export const editOnCallPolicyUrl = data => post(url.BASE_URL + "/oncall/update-oncall-policy", data);

export const deleteSpecificOnCallPolicyUrl = data => post(url.BASE_URL + "/oncall/delete-oncall-policy", data);

export const postInitialOnboarding = data => post(url.BASE_URL + "/initial-onboarding", data);

export const postNewRelicOnboardingUrl = data => post(url.BASE_URL + "/newrelic/onboarding", data);

export const postDatadogOnboardingUrl = data => post(url.BASE_URL + "/datadog/onboarding", data);

export const postSplunkOnboardingUrl = data => post(url.BASE_URL + "/splunk/onboarding", data);

export const postOciOnboardingUrl = data => post(url.BASE_URL + "/oci/onboarding", data);

export const postSentryOnboardingUrl = data => post(url.BASE_URL + "/sentry/onboarding", data);

export const postLokiOnboardingUrl = data => post(url.BASE_URL + "/loki/onboarding", data);

export const postCoralogixOnboardingUrl = data => post(url.BASE_URL + "/coralogix/onboarding", data);

export const postLokiServiceMappingUrl = data => post(url.BASE_URL + "/loki/map-service-to-loki-job", data);

export const postCoralogixServiceMappingUrl = data => post(url.BASE_URL + "/coralogix/map-service-to-subsystem", data);

export const postSentryServiceMappingUrl = data => post(url.BASE_URL + "/sentry/map-service-to-sentry-project", data);

export const postServiceOnboarding = data => post(url.BASE_URL + "/service-onboarding", data);

export const postCreateAlertsUrl = data => post(url.BASE_URL + "/create-alerts", data)

export const postServiceMapping = data => post(url.BASE_URL + "/map-resources-to-service", data);

export const getRescanStatusAwsUrl = data => get(url.BASE_URL + "/user-scan-status", data);

export const getRescanStatusNewRelicUrl = data => get(url.BASE_URL + "/newrelic/user-scan-status", data);

export const getRescanStatusAzureUrl = data => get(url.BASE_URL + "/azure/user-scan-status", data);

export const getRescanStatusGCPUrl = data => get(url.BASE_URL + "/gcp/user-scan-status", data);

export const getRescanStatusDatadogUrl = data => get(url.BASE_URL + "/datadog/user-scan-status", data);

export const getRescanStatusSplunkUrl = data => get(url.BASE_URL + "/splunk/user-scan-status", data);

export const postGCPServiceMapping = data => post(url.BASE_URL + "/gcp/map-gcp-resources-to-service", data);

export const postAzureServiceMapping = data =>post(url.BASE_URL + '/azure/map-azure-resources-to-service', data);

export const postResourceOpsgenieTeamMapping = (data) => post(url.BASE_URL + "/map-resources-to-opsgenie-team", data);

export const postGCPResourceOpsgenieTeamMapping = (data) => post(url.BASE_URL + "/gcp/map-gcp-resources-to-opsgenie-team", data);

export const postAzureResourceOpsgenieTeamMapping = (data) => post(url.BASE_URL + "/azure/map-azure-resources-to-opsgenie-team", data);

export const postResourcePagerdutyServiceMappingCall = (data) => post(url.BASE_URL + "/map-resources-to-pagerduty-service", data);

export const postGCPResourcePagerdutyServiceMappingCall = (data) => post(url.BASE_URL + "/gcp/map-gcp-resources-to-pagerduty-service", data);

export const postAzureResourcePagerdutyServiceMappingCall = (data) => post(url.BASE_URL + "/azure/map-azure-resources-to-pagerduty-service", data);

export const postNewRelicResourcePagerdutyServiceMappingCall = (data) => post(url.BASE_URL + "/newrelic/map-resources-to-pagerduty-service", data);

export const postDataDogResourcePagerdutyServiceMappingCall = (data) => post(url.BASE_URL + "/datadog/map-resources-to-pagerduty-service", data);

export const postSplunkResourcePagerdutyServiceMappingCall = (data) => post(url.BASE_URL + "/splunk/map-resources-to-pagerduty-service", data);

export const postNewRelicResourceOpsgenieTeamMapping = (data) => post(url.BASE_URL + "/newrelic/map-resources-to-opsgenie-team", data);

export const postDatadogResourceOpsgenieTeamMapping = (data) => post(url.BASE_URL + "/datadog/map-resources-to-opsgenie-team", data);

export const postSplunkResourceOpsgenieTeamMapping = (data) => post(url.BASE_URL + "/splunk/map-resources-to-opsgenie-team", data);

export const postNewRelicServiceMappingUrl = data => post(url.BASE_URL + "/newrelic/map-resources-to-service", data);

export const postDatadogServiceMappingUrl = data => post(url.BASE_URL + "/datadog/map-resources-to-service", data);

export const postSplunkServiceMappingUrl = data => post(url.BASE_URL + "/splunk/map-resources-to-service", data);

export const getMetrics = data => get(url.BASE_URL + "/metric?master_resource_id=" + data);

export const getAlertsUrl = data => get(url.BASE_URL + "/alert?monitored_resource_id=" + data);

export const getGCPAlertsUrl = data => get(url.BASE_URL + "/gcp/alert?monitored_resource_id=" + data);

export const getAzureAlertsUrl = data => get(url.BASE_URL + "/azure/alert?monitored_resource_id=" + data);

export const getAlertsFullUrl = data => get(url.BASE_URL + "/alert");

export const getScoresUrl = data => get(url.BASE_URL + "/coverage-score?scan_id=" + data);

export const getMasterResourcesUrl = data => get(url.BASE_URL + "/master-resource");


export const getAlertLogCountByIntegrationTypeURL = (data) => {
  const callURL = url.BASE_URL + "/alert-manager/alert-log-count-for-thirty-days-integration-type";
  const params = new URLSearchParams();
  if (data.teamIds && data.teamIds.length > 0) {
    params.append('teamIds', data.teamIds.join(','));
  }
  if (data.startDate) {
    params.append('start_date', data.startDate);
  }
  if (data.endDate) {
    params.append('end_date', data.endDate);
  }

    const queryString = params.toString();
    return get(queryString ? `${callURL}?${queryString}` : callURL);
};


export const getMostFrequentAlertsForOptimizationUrl = (data) => {
  let callURL = url.BASE_URL + "/alert-manager/most-frequent-alerts-last-thirty-days-for-optimization";
  if (data.teamIds && data.teamIds.length > 0) {
    callURL += "?teamIds=" + data.teamIds.join(",");
  }
  return get(callURL);
};

export const getAlertLogCountByApplicationServiceURL = (data) => {
  const baseURL = url.BASE_URL + "/alert-manager/alert-log-count-for-thirty-days-by-service-id";
  const params = new URLSearchParams();

  if (data.teamIds && data.teamIds.length > 0) {
    params.append('teamIds', data.teamIds.join(','));
  }
  if (data.startDate) {
    params.append('start_date', data.startDate);
  }
  if (data.endDate) {
    params.append('end_date', data.endDate);
  }

  const queryString = params.toString();
  return get(queryString ? `${baseURL}?${queryString}` : baseURL);
};


export const getThreshold = data => get(url.BASE_URL + "/default-threshold?threshold_type=" + data);

export const getGCPThreshold = data => get(url.BASE_URL + "/gcp/default-threshold-existing-resources");

export const getAzureThreshold = data => get(url.BASE_URL + "/azure/default-threshold-existing-resources");


export const getMostFrequentAlertsURL = (data) => {
  const baseURL = url.BASE_URL + "/alert-manager/most-frequent-alerts-last-thirty-days";
  const params = new URLSearchParams();

  if (data.teamIds && data.teamIds.length > 0) {
      params.append('teamIds', data.teamIds.join(','));
  }
  if (data.startDate) {
      params.append('start_date', data.startDate);
  }
  if (data.endDate) {
      params.append('end_date', data.endDate);
  }

  const queryString = params.toString();
  return get(queryString ? `${baseURL}?${queryString}` : baseURL);
};


export const getRecentlyAddedResourcesAWSUrl = (data) => {
  let callURL = url.BASE_URL + "/recently-added-resources?last_number_of_days=" + data.last_number_of_days;
  if (data.page) {
    callURL += "&page=" + data.page; 
  }
  if (data.per_page) {
    callURL += "&per_page=" + data.per_page; 
  }
  return get(callURL);
};

export const getRecentlyAddedResourcesGCPUrl = (data) => {
  let callURL = url.BASE_URL + "/gcp/recently-added-resources?last_number_of_days=" + data.last_number_of_days;
  if (data.page) {
    callURL += "&page=" + data.page; 
  }
  if (data.per_page) {
    callURL += "&per_page=" + data.per_page;
  }
  return get(callURL);
};

export const getRecentlyAddedResourcesAzureUrl = (data) => {
  let callURL = url.BASE_URL + "/azure/recently-added-resources?last_number_of_days=" + data.last_number_of_days;
  if (data.page) {
    callURL += "&page=" + data.page; 
  }
  if (data.per_page) {
    callURL += "&per_page=" + data.per_page; 
  }
  return get(callURL);
};

export const getRecentlyAddedResourcesDatadogUrl = (data) => {
  let callURL = url.BASE_URL + "/datadog/recently-added-resources?last_number_of_days=" + data.last_number_of_days;
  if (data.page) {
    callURL += "&page=" + data.page;
  }
  if (data.per_page) {
    callURL += "&per_page=" + data.per_page; 
  }
  return get(callURL);
};

export const getRecentlyAddedResourcesNewRelicUrl = (data) => {
  let callURL = url.BASE_URL + "/newrelic/recently-added-resources?last_number_of_days=" + data.last_number_of_days;
  if (data.page) {
    callURL += "&page=" + data.page; 
  }
  if (data.per_page) {
    callURL += "&per_page=" + data.per_page;
  }
  return get(callURL);
};

export const getRecentlyAddedResourcesAppDynamicsUrl = (data) => {
  let callURL = url.BASE_URL + "/app-dynamics/recently-added-resources?last_number_of_days=" + data.last_number_of_days;
  if (data.page) {
    callURL += "&page=" + data.page; 
  }
  if (data.per_page) {
    callURL += "&per_page=" + data.per_page;
  }
  return get(callURL);
};

export const getRecentlyAddedResourcesGrafanaUrl = (data) => {
  let callURL = url.BASE_URL + "/grafana/recently-added-resources?last_number_of_days=" + data.last_number_of_days;
  if (data.page) {
    callURL += "&page=" + data.page;
  }
  if (data.per_page) {
    callURL += "&per_page=" + data.per_page;
  }
  return get(callURL);
}

export const getRecentlyAddedResourcesSignozUrl = (data) => {
  let callURL = url.BASE_URL + "/signoz/recently-added-resources?last_number_of_days=" + data.last_number_of_days;
  if (data.page) {
    callURL += "&page=" + data.page;
  }
  if (data.per_page) {
    callURL += "&per_page=" + data.per_page;
  }
  return get(callURL);
}

export const getRecentlyAddedResourcesSplunkUrl = (data) => {
  let callURL = url.BASE_URL + "/splunk/recently-added-resources?last_number_of_days=" + data.last_number_of_days;
  if (data.page) {
    callURL += "&page=" + data.page;
  }
  if (data.per_page) {
    callURL += "&per_page=" + data.per_page;
  }
  return get(callURL)
};

export const getRecentlyAddedResourcesDynatraceUrl = (data) => {
    let callURL = url.BASE_URL + "/dynatrace/recently-added-resources?last_number_of_days=" + data.last_number_of_days;
    if (data.page) {
        callURL += "&page=" + data.page;
    }
    if (data.per_page) {
        callURL += "&per_page=" + data.per_page;
    }
    return get(callURL)
}

export const getRecentlyAddedResourcesOciUrl = (data) => {
    let callURL = url.BASE_URL + "/oci/recently-added-resources?last_number_of_days=" + data.last_number_of_days;
    if (data.page) {
        callURL += "&page=" + data.page;
    }
    if (data.per_page) {
        callURL += "&per_page=" + data.per_page;
    }
    return get(callURL)
}

export const getRecentlyAddedResourcesSyntheticsUrl = (data) => {
  let callURL = url.BASE_URL + "/ping-monitoring/recently-added-resources?last_number_of_days=" + data.last_number_of_days;
  if (data.page) {
    callURL += "&page=" + data.page;
  }
  if (data.per_page) {
    callURL += "&per_page=" + data.per_page;
  }
  return get(callURL)
}

export const getAlertsOpenAndCloseWithin5MinURL = (data) => {
  const callURL = url.BASE_URL + "/alert-manager/alert-logs-closed-within-5-minutes-last-thirty-days-paginated";
  const params = new URLSearchParams();

  if (data.page) {
    params.append('page', data.page);
  }
  if (data.limit) {
    params.append('per_page', data.limit);
  }
  if (data.teamIds && data.teamIds.length > 0) {
    params.append('teamIds', data.teamIds.join(','));
  }
  if (data.startDate) {
    params.append('start_date', data.startDate);
  }
  if (data.endDate) {
    params.append('end_date', data.endDate);
  }

    const queryString = params.toString();
    return get(queryString ? `${callURL}?${queryString}` : callURL);
};

export const getAlertsOpenAndCloseWithin5MinCountURL = (data) => {

  const callURL = url.BASE_URL + "/alert-manager/alert-logs-closed-within-5-minutes-last-thirty-days-count";
  const params = new URLSearchParams();
  if (data.page) {
    params.append('page', data.page);
  }
  if (data.limit) {
    params.append('per_page', data.limit);
  }
  if (data.teamIds && data.teamIds.length > 0) {
    params.append('teamIds', data.teamIds.join(','));
  }
  if (data.startDate) {
    params.append('start_date', data.startDate);
  }
  if (data.endDate) {
      params.append('end_date', data.endDate);
  }

  const queryString = params.toString();
  return get(queryString ? `${callURL}?${queryString}` : callURL);
};

export const getPaginatedUsersURL = (data) => {
  let callURL = url.BASE_URL + "/users-paginated?";

  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.searchTerm ) {
    callURL += "&search_term=" + data.searchTerm;
  }
  return get(callURL);
};
export const getUsersCountURL = (data) => {
  let callURL = url.BASE_URL + "/users-count?";
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.searchTerm ) {
    callURL += "&search_term=" + data.searchTerm;
  }
  return get(callURL);
};

export const getMostFrequentAlertsAzureUrl = (data) => {

  let callURL = url.BASE_URL + "/alert-manager/most-frequent-azure-alerts-for-optimization?"
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.teamIds && data.teamIds.length > 0) {
    callURL += "&teamIds=" + data.teamIds.join(",");
  }

  return get(callURL);
};
export const getMostFrequentAlertsAwsUrl = (data) => {

  let callURL = url.BASE_URL + "/alert-manager/most-frequent-cloudwatch-alerts-for-optimization?"
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.teamIds && data.teamIds.length > 0) {
    callURL += "&teamIds=" + data.teamIds.join(",");
  }

  return get(callURL);
};
export const getMostFrequentAlertsNewRelicUrl = (data) => {

  let callURL = url.BASE_URL + "/alert-manager/most-frequent-newrelic-alerts-for-optimization?"
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.teamIds && data.teamIds.length > 0) {
    callURL += "&teamIds=" + data.teamIds.join(",");
  }

  return get(callURL);
};
export const getMostFrequentAlertsGcpUrl = (data) => {

  let callURL = url.BASE_URL + "/alert-manager/most-frequent-gcp-alerts-for-optimization?"
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.teamIds && data.teamIds.length > 0) {
    callURL += "&teamIds=" + data.teamIds.join(",");
  }

  return get(callURL);
};
export const getMostFrequentAlertsDatadogUrl = (data) => {

  let callURL = url.BASE_URL + "/alert-manager/most-frequent-datadog-alerts-for-optimization?"
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.teamIds && data.teamIds.length > 0) {
    callURL += "&teamIds=" + data.teamIds.join(",");
  }

  return get(callURL);
};


export const getMostFrequentOtherAlertsUrl = (data) => {

  let callURL = url.BASE_URL + "/alert-manager/most-frequent-alerts-last-thirty-days-other-alerts?"
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.teamIds && data.teamIds.length > 0) {
    callURL += "&teamIds=" + data.teamIds.join(",");
  }

  return get(callURL);
};

export const getMostFrequentAlertsBasedOnIntegrationUrl = (data) => {
  let callURL = url.BASE_URL + "/alert-manager/most-frequent-alerts-for-optimization-based-on-integration-type?";
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.teamIds && data.teamIds.length > 0) {
    callURL += "&teamIds=" + data.teamIds.join(",");
  }
  if (data.integration){
    callURL += "&integration_type=" + data.integration;
  }
  return get(callURL);
}

export const postAcceptSuggestionsURL = (data) => get(url.BASE_URL + "/alert-manager/suggestion-accepted?suggestion_id=" + data);

export const postSetupAlertUrl = data => post(url.BASE_URL + "/setup-alert", data);

export const postDisableAlertUrl = data => post(url.BASE_URL + "/disable-alerts-by-alert-ids", data);

export const postEnableAlertUrl = data => post(url.BASE_URL + "/enable-alerts-by-alert-ids", data);

export const postDisableGCPAlertUrl = data => post(url.BASE_URL + "/gcp/disable-alerts-by-alert-ids", data);

export const postEnableGCPAlertUrl = data => post(url.BASE_URL + "/gcp/enable-alerts-by-alert-ids", data);

export const postDisableAzureAlertUrl = data => post(url.BASE_URL + "/azure/disable-alerts-by-alert-ids", data);

export const postEnableAzureAlertUrl = data => post(url.BASE_URL + "/azure/enable-alerts-by-alert-ids", data);

export const postDisableThresholdAlertUrl = data => put(url.BASE_URL + "/enable-disable-default-threshold", data);

export const getServiceQuotaThresholdUrl = data => get(url.BASE_URL + "/service-quota-threshold");

export const getQuotaMasterResourcesUrl = data => get(url.BASE_URL + "/quota-master-resources");

export const onDeployMasterResourceAlertsUrl = data => post(url.BASE_URL + "/create-service-quota-alerts", data);

export const updateMasterResourceAlertsConfigUrl = data => post(url.BASE_URL + "/service-quota-threshold", data);

export const getDeployedServiceQuotaAlertsUrl = () => get(url.BASE_URL + "/deployed-service-quota-alerts");

export const updateDeployedAlertsUrl = data => put(url.BASE_URL + "/update-deployed-alert", data);

export const postEnableThresholdAlertUrl = data => put(url.BASE_URL + "/enable-disable-default-threshold", data);

export const postDisableGCPThresholdAlertUrl = data => put(url.BASE_URL + "/gcp/enable-disable-default-threshold", data);

export const postEnableGCPThresholdAlertUrl = data => put(url.BASE_URL + "/gcp/enable-disable-default-threshold", data);

export const postDisableAzureThresholdAlertUrl = data => put(url.BASE_URL + "/azure/enable-disable-default-threshold", data);

export const postEnableAzureThresholdAlertUrl = data => put(url.BASE_URL + "/azure/enable-disable-default-threshold", data);

export const postNewRelicDisableThresholdAlertUrl = data => put(url.BASE_URL + "/newrelic/enable-disable-default-threshold", data);

export const postDatadogDisableThresholdAlertUrl = data => put(url.BASE_URL + "/datadog/enable-disable-default-threshold", data);

export const postNewRelicEnableThresholdAlertUrl = data => put(url.BASE_URL + "/newrelic/enable-disable-default-threshold", data);

export const postDatadogEnableThresholdAlertUrl = data => put(url.BASE_URL + "/datadog/enable-disable-default-threshold", data);

export const postSplunkToggleThresholdAlertUrl = data => put(url.BASE_URL + "/splunk/enable-disable-default-threshold", data);

export const postMarkTransactionAsKeyTransactionUrl = data => post(url.BASE_URL + "/newrelic/mark-transaction-to-key-transaction", data)

export const postDeleteKeyTransactionUrl = data => put(url.BASE_URL + "/newrelic/delete-key-transaction", data)

export const postRegisterEndpointDatadogUrl = data => post(url.BASE_URL + "/datadog/register-api-endpoint", data)

export const postUpdateThresholdUrl = data => put(url.BASE_URL + "/default-threshold", data);

export const postUpdateGCPThresholdUrl = data => put(url.BASE_URL + "/gcp/default-threshold", data);

export const postUpdateAzureThresholdUrl = data => put(url.BASE_URL + "/azure/default-threshold", data);

export const postDisableResourceAlertUrl = data => post(url.BASE_URL + "/disable-alerts-by-resource-id", data);

export const postEnableResourceAlertUrl = data => post(url.BASE_URL + "/enable-alerts-by-resource-id", data);

export const putUpdateAlertUrl = data => put(url.BASE_URL + "/alert", data);

export const putUpdateGCPAlertUrl = data => put(url.BASE_URL + "/gcp/alert", data);

export const putUpdateAzureAlertUrl = data => put(url.BASE_URL + "/azure/alert", data);

export const getMissingAlertsUrl = data => get(url.BASE_URL + "/missing-alert?alert_coverage_score_id=" + data);

export const postMapResourceToEmailUrl = data => post(url.BASE_URL + "/map-resource-to-service-email", data);

export const postCreateAwsResourceAlertsUrl = data => post(url.BASE_URL + "/create-aws-resource-alerts", data);

export const postCreateGcpResourceAlertsUrl = data => post(url.BASE_URL + "/gcp/create-gcp-resource-alerts", data);

export const postCreateAzureResourceAlertsUrl = data => post(url.BASE_URL + "/azure/create-azure-resource-alerts", data);

export const postCreateAzureResourceAlertsDynamicUrl = data => post(url.BASE_URL + "/azure/create-dynamic-alert", data);

export const getCloudDetailsUrl = () => get(url.BASE_URL + "/cloud");

export const getAwsScanUrl = () => get(url.BASE_URL + "/scan");

export const getNotificationChannelsUrl = () => get(url.BASE_URL + "/notification-channel");

export const getGCPNotificationChannelsUrl = () => get(url.BASE_URL + "/notification-channel");

export const getAzureNotificationChannelsUrl = () => get(url.BASE_URL + "/notification-channel");

export const getNewRelicAlertsUrl = data => get(url.BASE_URL + "/newrelic/alert?new_relic_resource_id=" + data);

export const getDatadogAlertsUrl = data => get(url.BASE_URL + "/datadog/alert?datadog_resource_id=" + data);

export const getSplunkAlertsUrl = data => get(url.BASE_URL + "/splunk/alert?splunk_resource_id=" + data);

export const getNewRelicDynamicAlertsDeployedByResourceId = data => post(url.BASE_URL + "/newrelic/get-dynamic-alerts", data)

export const getDatadogDynamicAlertsDeployedByResourceId = data => post(url.BASE_URL + "/datadog/get-dynamic-alerts", data)

export const getSplunkDynamicAlertsDeployedByResourceId = data => post(url.BASE_URL + "/splunk/get-dynamic-alerts", data)

export const getNewRelicDynamicAlertsMissingByResourceId = data => post(url.BASE_URL + "/newrelic/get-missing-dynamic-alerts", data)

export const getDatadogMissingDynamicAlertsByResourceId = data => post(url.BASE_URL + "/datadog/get-missing-dynamic-alerts", data)

export const getSplunkMissingDynamicAlertsByResourceId = data => post(url.BASE_URL + "/splunk/get-missing-dynamic-alerts", data)

export const deployNewRelicDynamicAlertsByResourceIdUrl = data => post(url.BASE_URL + "/newrelic/create-dynamic-alert", data);

export const getNewRelicMetricsUrl = data => get(url.BASE_URL + "/newrelic/metric?master_resource_id=" + data);

export const getNewRelicDefaultThresholdUrl = data => get(url.BASE_URL + "/newrelic/default-threshold?threshold_type=" + data);

export const getDatadogDefaultThresholdUrl = data => get(url.BASE_URL + "/datadog/default-threshold?threshold_type=" + data);

export const getSplunkDefaultThresholdUrl = data => get(url.BASE_URL + "/splunk/default-threshold?threshold_type=" + data);

export const getNewRelicMissingAlertsUrl = data => get(url.BASE_URL + "/newrelic/missing-alert?alert_coverage_score_id=" + data);

export const getNewRelicCompletedAlertsUrl = () => get(url.BASE_URL + "/newrelic/alert");

export const postNewRelicCreateAlertsUrl = data => post(url.BASE_URL + "/newrelic/create-nr-resource-alerts", data);

export const postDatadogCreateAlertsUrl = data => post(url.BASE_URL + "/datadog/create-datadog-resource-alerts", data);

export const postSplunkCreateAlertsUrl = data => post(url.BASE_URL + "/splunk/create-splunk-resource-alerts", data);

export const postNewRelicSetupAlertUrl = data => post(url.BASE_URL + "/newrelic/setup-alert", data);

export const postNewRelicDisableAlertUrl = data => post(url.BASE_URL + "/newrelic/disable-alerts-by-alert-ids", data);

export const postDatadogDisableAlertUrl = data => post(url.BASE_URL + "/datadog/disable-alerts-by-alert-ids", data);

export const postSplunkDisableAlertUrl = data => post(url.BASE_URL + "/splunk/disable-alerts-by-alert-ids", data);

export const postNewRelicEnableAlertUrl = data => post(url.BASE_URL + "/newrelic/enable-alerts-by-alert-ids", data);

export const postDatadogEnableAlertUrl = data => post(url.BASE_URL + "/datadog/enable-alerts-by-alert-ids", data);

export const postSplunkEnableAlertUrl = data => post(url.BASE_URL + "/splunk/enable-alerts-by-alert-ids", data);

export const postNewRelicUpdateThresholdUrl = data => put(url.BASE_URL + "/newrelic/default-threshold", data);

export const postDatadogUpdateThresholdUrl = data => put(url.BASE_URL + "/datadog/default-threshold", data);

export const postSplunkUpdateThresholdUrl = data => put(url.BASE_URL + "/splunk/default-threshold", data);

export const postNewRelicDisableResourceAlertUrl = data => post(url.BASE_URL + "/newrelic/disable-alerts-by-resource-id", data);

export const postNewRelicEnableResourceAlertUrl = data => post(url.BASE_URL + "/newrelic/enable-alerts-by-resource-id", data);

export const putNewRelicUpdateAlertUrl = data => put(url.BASE_URL + "/newrelic/alert", data);

export const putDatadogUpdateAlertUrl = data => put(url.BASE_URL + "/datadog/alert", data);

export const putSplunkUpdateAlertUrl = data => put(url.BASE_URL + "/splunk/alert", data);

export const getAllMissingAlertsUrl = () => get(url.BASE_URL + "/all-missing-alerts");

export const getAlcomScoreUrl = () => get(url.BASE_URL + "/alcom-score");

export const getAWSMissingAlertsByResourceIDUrl = data => get(url.BASE_URL + "/missing-alert-by-aws-resource-id?monitored_resource_id=" + data);

export const getGCPMissingAlertsByResourceIDUrl = data => get(url.BASE_URL + "/gcp/missing-alert-by-gcp-resource-id?monitored_resource_id=" + data);

export const getAzureMissingAlertsByResourceIDUrl = data => get(url.BASE_URL + "/azure/missing-alert-by-azure-resource-id?monitored_resource_id=" + data);

export const getAzureDynamicAlertsUrl = data =>get(url.BASE_URL + "/azure/get-dynamic-alert?monitored_resource_id=" + data);

export const getAzureMissingDynamicAlertsByResourceIdUrl = data => get(url.BASE_URL + "/azure/missing-dynamic-alert-by-azure-resource-id?monitored_resource_id=" + data)

export const getAWSMissingDynamicAlertsByResourceIdUrl = data => post(url.BASE_URL + "/get-missing-dynamic-alerts", data)

export const getAWSDynamicAlertsDeployedByResourceIdUrl = data => post(url.BASE_URL + "/get-dynamic-alerts", data);

export const deployAWSDynamicAlertsByResourceIdUrl = data => post(url.BASE_URL + "/set-dynamic-alert", data);

export const getDefaultThresholdByMonitoredResourceIDUrl = data => get(url.BASE_URL + "/default-threshold-by-monitored-resource?monitored_resource_id=" + data);

export const getDefaultGCPThresholdByMonitoredResourceIDUrl = data => get(url.BASE_URL + "/gcp/default-threshold-by-monitored-resource?monitored_resource_id=" + data);

export const getDefaultAzureThresholdByMonitoredResourceIDUrl = data => get(url.BASE_URL + "/azure/default-threshold-by-monitored-resource?monitored_resource_id=" + data);

export const getAWSResourceByIDUrl = data => get(url.BASE_URL + "/resource-by-id?monitored_resource_id=" + data);

export const getGCPResourceByIDUrl = data => get(url.BASE_URL + "/gcp/resource-by-id?monitored_resource_id=" + data);

export const getAzureResourceByIDUrl = data => get(url.BASE_URL + "/azure/resource-by-id?monitored_resource_id=" + data);

export const getNewRelicResourceByIDUrl = data => get(url.BASE_URL + "/newrelic/resource-by-id?monitored_resource_id=" + data);

export const getDatadogResourceByIDUrl = data => get(url.BASE_URL + "/datadog/resource-by-id?monitored_resource_id=" + data);

export const getSplunkResourceByIDUrl = data => get(url.BASE_URL + "/splunk/resource-by-id?monitored_resource_id=" + data);

export const getDefaultThresholdsNewRelicResourceByIDUrl = data => get(url.BASE_URL + "/newrelic/newrelic-default-threshold-by-monitored-resource?monitored_resource_id=" + data);

export const getDefaultThresholdsDatadogResourceByIDUrl = data => get(url.BASE_URL + "/datadog/datadog-default-threshold-by-monitored-resource?monitored_resource_id=" + data);

export const getDefaultThresholdsSplunkResourceByIDUrl = data => get(url.BASE_URL + "/splunk/splunk-default-threshold-by-monitored-resource?monitored_resource_id=" + data);

export const getNRMissingAlertsByResourceIDUrl = data => get(url.BASE_URL + "/missing-alert-by-newrelic-resource-id?monitored_resource_id=" + data);

export const getDatadogMissingAlertsByResourceIDUrl = data => get(url.BASE_URL + "/missing-alert-by-datadog-resource-id?monitored_resource_id=" + data);

export const getSplunkMissingAlertsByResourceIDUrl = data => get(url.BASE_URL + "/splunk/missing-alert-by-splunk-resource-id?monitored_resource_id=" + data);

export const getAWSChartsDataUrl = () => get(url.BASE_URL + "/aws-chart-data");

export const getOrganizationDetails = () => get(url.BASE_URL + "/organization");

export const updateBillingDetails = data => post(url.BASE_URL + "/update-billing-details", data);

export const getSubscriptionDetails = () => get(url.BASE_URL + "/subscription/current-plan");

export const getAlertDeploymentCountUrl = () => get(url.BASE_URL + "/activity-log/scans-alerts-count");

export const getResourceScanCountUrl = () => get(url.BASE_URL + '/activity-log/resource-scan-count');

export const getMonthlyResourceCountUrl = () => get(url.BASE_URL + "/activity-log/resource-count/monthly");

export const getDailyResourceCountUrl = () => get(url.BASE_URL + "/activity-log/resource-count/current");

export const getUsersUrl = () => get(url.BASE_URL + url.GET_USERS);

export const getExternalUsersCountUrl = () => get(url.BASE_URL + "/external-users-count")

export const getDeletedUsersUrl = () => get(url.BASE_URL + url.GET_DELETED_USERS);

export const getOncallEligibleUsersUrl = () => get(url.BASE_URL + url.GET_ONCALL_ELIGIBLE_USERS);

export const inviteUserUrl = data => post(url.BASE_URL + "/invite-user", data);

export const deleteUserUrl = data => post(url.BASE_URL + "/delete-user", data);

export const updateUserUrl = data => {const { user_id, ...rest } = data;
return put(url.BASE_URL+"/update-user/"+user_id, rest);
};

export const deleteAllowedDomainRestrictionUrl = data => post(url.BASE_URL + "/organization/delete-allowed-domain", data);

export const postAllowedDomainRestrictionUrl = data => post(url.BASE_URL + "/organization/allowed-domains", data);

export const getSsoLoginOnlyUrl = () => get(url.BASE_URL + "/organization/sso-only-login");

export const toggleStatusPageUrl = () => get(url.BASE_URL + "/statuspage/toggle-status-page-publish");

export const toggleSsoLoginOnlyUrl = () => get(url.BASE_URL + "/organization/toggle-sso-only-login");

export const updateTwoFactorEnabledUrl = (data) => post(url.BASE_URL + "/organization/enable-disable-two-factor", data);

export const forgotPasswordUrl = data => post(url.BASE_URL + "/forgot-password", data);

export const inviteConfirmationUrl = (token, data) => post(url.BASE_URL + "/invite-confirmation/" + token, data);

export const getOrgSsoStatusUrl = () => get(url.BASE_URL + "/organization/sso-status");

export const resetPasswordUrl = (token, data) => post(url.BASE_URL + "/reset-password/" + token, data);

export const oktaLoginFlowUrl = data => post(url.BASE_URL + "/authorization-code/callback", data);

export const logoutUrl = () => post(url.BASE_URL + "/logout");

export const googleSsoLoginUrl = (data) => post(url.BASE_URL + "/google-sso/login", data)

export const googleSsoSetCookieUrl = (data) => post(url.BASE_URL + "/sso/set-cookie", data)

export const postSsoOnlyLoginStatusUrl = (data) => post(url.BASE_URL + "/organization/subdomain-sso-only-login", data);

export const postCanUserRequestOtpUrl = (data) => post(url.BASE_URL + "/can-user-request-otp", data);

export const postRequestOtpUrl = (data) => post(url.BASE_URL + "/send-otp", data);

export const postVerifyOtpUrl = (data) => post(url.BASE_URL + "/verify-otp", data);

export const getRolesUrl = () => get(url.BASE_URL + "/acl/roles");

export const updateRolesUrl = (data) => post(url.BASE_URL + "/acl/update-user-role", data);

export const unmapServiceFromTeamUrl = (data) => post(url.BASE_URL + "/acl/delete-service-from-team", data);

export const getUnmappedServicesUrl = (team_id) => get(url.BASE_URL + "/acl/team-unmapped-services?team_id=" + team_id);

export const addUsersToTeamUrl = (data) => post(url.BASE_URL + "/acl/add-users-to-team", data);

export const getNonTeamMembersUrl = (data) => post(url.BASE_URL + "/acl/non-team-members", data);

export const mapServicesToTeamUrl = (data) => post(url.BASE_URL + "/acl/map-services-to-team", data);

export const removeUserFromTeamUrl = (data) => post(url.BASE_URL + "/acl/remove-user-from-team", data);

export const getOrgPrimaryNotificationChannelsUrl = () => get(url.BASE_URL + "/notification-channel");

export const updateOrgPrimaryNotificationChannelsUrl = (data) => post(url.BASE_URL + "/set-primary-notification-channel", data);

export const getOrgAwsServicesListUrl = () => get(url.BASE_URL+"/org-aws-service-list");

export const postUpdateStatusOrgAwsServicesUrl = (data) =>post(url.BASE_URL+"/update-org-aws-service-lists", data);
export const emailConfirmationUrl = (token) => get(url.BASE_URL + "/confirmation/" + token);

export const getTeamAlcomScoresUrl = (data) => post(url.BASE_URL + "/alcom-score-by-team-ids", data);

export const getServiceAlcomScoresUrl = (data) => post(url.BASE_URL + "/alcom-score-by-service-ids", data);

export const getUnmappedResourceAlcomScoresUrl = () => get(url.BASE_URL + "/alcom-score-unmapped-resources");

export const getMTTAMTTRMetricsUrl = (data) => post(url.BASE_URL + "/alert-manager/mtta-mttr", data)

export const getMTTAMTTRMetricsForTeamsUrl = (data) => post(url.BASE_URL + "/alert-manager/mtta-mttr-by-teams", data)

export const serviceEmailConfirmationUrl = (token) => get(url.BASE_URL + "/service-email-confirmation/" + token);

export const postUpdateResourceEnvironmentUrl = (data) => post(url.BASE_URL + "/update-resource-environment", data);

export const postCheckoutUrl = (data) => post(url.BASE_URL + "/subscription/create-checkout-session", data);

export const postUpdateNewRelicResourceEnvironmentUrl = (data) => post(url.BASE_URL + "/newrelic/update-resource-environment", data);

export const createBluejayTeamUrl = (data) => post(url.BASE_URL + "/acl/create-team", data)

export const createMSTeamsChannelUrl = (data) => post(url.BASE_URL + "/msteams/channel", data)

export const getMSTeamsChannelsUrl = (data) => get(url.BASE_URL + "/msteams/channels")

export const deleteMsTeamsChannelUrl = (data) => post(url.BASE_URL + "/msteams/delete-channel", data)

export const getBluejayTeamsUrl = () => get(url.BASE_URL + "/acl/teams")

export const deleteBluejayTeamUrl = (data) => post(url.BASE_URL + "/acl/delete-team", data)

export const updateBluejayTeamUrl = (data) => post(url.BASE_URL + "/acl/update-team", data)

//rca
export const getRcaUrl = (data) => {
  let callURL = url.BASE_URL + "/rca/all-rca?";
  if (data.limit) {
    callURL += "per_page=" + data.limit;
  }
  if (data.page) {
    callURL += "&page=" + data.page
  }
  if (data.filter_type){
    callURL += "&filter_type=" + data.filter_type;
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }
  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }
  if (data.status){
    callURL += "&status=" + data.status;
  }
  if (data.date_created){
    callURL += "&date_created=" + data.date_created;
  }
  if (data.owner){
    callURL += "&owner=" + data.owner;
  }
  if (data.reviewer){
    callURL += "&reviewer=" + data.reviewer;
  }

  return get(callURL);
}

// export const getRcaCountUrl = (data) => {
//   let callURL = url.BASE_URL + "/rca/rca-content";
//
//
// }

export const getRcaByIdUrl = (id) => get(url.BASE_URL + `/rca/${id}`);

export const deleteRcaByIdUrl = (id) => post(url.BASE_URL + '/rca/delete-rca', {rca_id: id});

export const getActionItemByIdUrl = (id) => get(url.BASE_URL + `/rca/action-item/${id}`);

export const postRcaUrl = (data) => post(url.BASE_URL + "/rca/rca", data);

export const postRcaContentUrl = (data) => post(url.BASE_URL + `/rca/rca-content`, data);

export const postFullRcaUrl = (data) => post(url.BASE_URL + "/rca/full-rca", data);

export const updateRcaImpactUrl = (data) => post(url.BASE_URL + "/rca/update-impact", data);

export const updateRcaTimelineUrl = (data) => post(url.BASE_URL + "/rca/update-timeline", data);

export const updateRcaQuestionsUrl = (data) => post(url.BASE_URL + "/rca/update-questions", data);

export const updateRcaIncidentDetailsUrl = (data) => post(url.BASE_URL + "/rca/update-incident-details",data);

export const updateRcaHeaderDetailsUrl = (data) => post(url.BASE_URL + "/rca/update-header-details",data);

export const updateActionItemStatusUrl = (data) => post(url.BASE_URL + "/rca/update-action-item-status", data);

export const updateRcaActionsUrl = (data) => post(url.BASE_URL + "/rca/update-actions", data);

export const updateRcaRelatedAlertsUrl = (data) => post(url.BASE_URL + "/rca/update-related-alerts", data);

export const updateRcaRelatedRcasUrl = (data) => post(url.BASE_URL + "/rca/update-related-rcas", data);

export const updateRcaImpactedApplicationsUrl = (data) => post(url.BASE_URL + "/rca/update-impacted-applications", data);

//appDynamics
export const getAppDynamicsThresholdUrl = () => get(url.BASE_URL + "/app-dynamics/default-threshold-existing-resources");

export const postAppDynamicsOnboardingUrl = data => post(url.BASE_URL + "/app-dynamics/onboarding", data);

export const getAppDynamicsResourcesUrl = () => get(url.BASE_URL + "/app-dynamics/resource");

export const getAllOrgAppDynamicsResourceTypesUrl = () => get(url.BASE_URL + "/app-dynamics/org-resource-types");

export const postUpdateAppDynamicsThresholdUrl = data => put(url.BASE_URL + "/app-dynamics/default-threshold", data);

export const postAppDynamicsEnableDisableAlertsUrl = (data) => post(url.BASE_URL + "/app-dynamics/enable-disable-alert-id", data);

export const postAppDynamicsCreateResourceAlertsUrl = (data) => post(url.BASE_URL + "/app-dynamics/create-appdynamics-resource-alerts", data);

export const postAppDynamicsCreateDynamicAlertUrl = (data) => post(url.BASE_URL + "/app-dynamics/create-dynamic-alert", data);

export const getAppDynamicsAlertUrl = monitored_resource_id => get(url.BASE_URL + "/app-dynamics/alert?monitored_resource_id=" + monitored_resource_id);

export const getAppDynamicsDynamicAlertsUrl = monitored_resource_id => get(url.BASE_URL + "/app-dynamics/get-dynamic-alerts?monitored_resource_id=" + monitored_resource_id);

export const getAppDynamicsMissingDynamicAlertsUrl = monitored_resource_id => get(url.BASE_URL + "/app-dynamics/get-missing-dynamic-alerts?monitored_resource_id=" + monitored_resource_id);

export const getAppDynamicsDefaultThresholdUrl = threshold_type => get(url.BASE_URL + "/app-dynamics/default-threshold?threshold_type=" + threshold_type);

export const getAppDynamicsResourceByIDUrl = data => get(url.BASE_URL + "/app-dynamics/resource-by-id?monitored_resource_id=" + data);

export const getAppDynamicsResourceDefaultThresholdByIdUrl = monitored_resource_id => get(url.BASE_URL + "/app-dynamics/default-threshold-by-monitored-resource?monitored_resource_id=" + monitored_resource_id);

export const postAppDynamicsAlertUrl = data => put(url.BASE_URL + "/app-dynamics/alert", data);

export const getAppDynamicsRescanUrl = () => get(url.BASE_URL + "/app-dynamics/refresh");

export const getAppDynamicsMissingAlertByResourceIdUrl = monitored_resource_id => get(url.BASE_URL + "/app-dynamics/missing-alert-by-resource-id?monitored_resource_id=" + monitored_resource_id );

export const getAppDynamicsResourceByIdUrl = monitored_resource_id => get(url.BASE_URL + "/app-dynamics/monitored_resource_id=" + monitored_resource_id)

export const postEnableDisableAppDynamicsThresholdUrl = data => post(url.BASE_URL + "/app-dynamics/enable-disable-default-threshold", data);

export const postMarkNonKeyTransactionAsBusinessTransactionUrl = data => post(url.BASE_URL + "/app-dynamics/mark-non-key-transaction-to-business-transaction", data);

export const getRescanStatusAppDynamicsUrl = data => get(url.BASE_URL + "/app-dynamics/user-scan-status", data);

export const getAppDynamicsAllResourceAlertsPageUrl = (data) => {
  let callURL = url.BASE_URL + "/app-dynamics/all-resource-alerts-paginated?"
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.environments && data.environments.length > 0) {
    data.environments.map((item) => {
      callURL += "&environments=" + item;
    });
  }
  if (data.health_filter && data.health_filter.length > 0) {
    data.health_filter.map((item) => {
      callURL += "&health_filter=" + item;
    });
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }
  if (data.region && data.region.length > 0) {
    callURL += "&region=" + data.region;
  }

  if (data.resource_types && data.resource_types.length > 0) {
    data.resource_types.map((item) => {
      callURL += "&resource_types=" + item;
    });
  }
  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }
  if ('application_service_ids' in data && data.application_service_ids.length > 0) {
    data.application_service_ids.map((item) => {
      callURL += "&application_service_ids=" + item;
    });
  } else if ('opsgenie_team_ids' in data && data.opsgenie_team_ids.length > 0) {
    data.opsgenie_team_ids.map((item) => {
      callURL += "&opsgenie_team_ids=" + item;
    })
  } else if ('pagerduty_service_ids' in data && data.pagerduty_service_ids.length > 0) {
    data.pagerduty_service_ids.map((item) => {
      callURL += "&pagerduty_service_ids=" + item;
    });
  }
  return get(callURL);
};

export const getAppDynamicsAllResourceAlertsCountPageUrl = (data) => {
  let callURL = url.BASE_URL + "/app-dynamics/get-resource-count?"
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.environments && data.environments.length > 0) {
    data.environments.map((item) => {
      callURL += "&environments=" + item;
    });
  }
  if (data.health_filter && data.health_filter.length > 0) {
    data.health_filter.map((item) => {
      callURL += "&health_filter=" + item;
    });
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }
  if (data.region && data.region.length > 0) {
    callURL += "&region=" + data.region;
  }

  if (data.resource_types && data.resource_types.length > 0) {
    data.resource_types.map((item) => {
      callURL += "&resource_types=" + item;
    });
  }
  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }
  if ('application_service_ids' in data && data.application_service_ids.length > 0) {
    data.application_service_ids.map((item) => {
      callURL += "&application_service_ids=" + item;
    });
  } else if ('opsgenie_team_ids' in data && data.opsgenie_team_ids.length > 0) {
    data.opsgenie_team_ids.map((item) => {
      callURL += "&opsgenie_team_ids=" + item;
    })
  } else if ('pagerduty_service_ids' in data && data.pagerduty_service_ids.length > 0) {
    data.pagerduty_service_ids.map((item) => {
      callURL += "&pagerduty_service_ids=" + item;
    });
  }
  return get(callURL);
};

export const getNonKeyTransactionsByParentResourceUrl = (data) => {
  let callURL = url.BASE_URL + "/app-dynamics/all-non-key-transactions-by-apm-paginated?";
  callURL += "parent_resource_id=" + data.parent_resource_id;
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.page) {
    callURL += "&page=" + data.page
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }
  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }

  return get(callURL);
}

export const getAppDynamicsAllBusinessTransactionAlertsUrl = (data) => {
  let callURL = url.BASE_URL + "/app-dynamics/all-business-transaction-alerts-paginated?"
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.environments && data.environments.length > 0) {
    data.environments.map((item) => {
      callURL += "&environments=" + item;
    });
  }
  if (data.health_filter && data.health_filter.length > 0) {
    data.health_filter.map((item) => {
      callURL += "&health_filter=" + item;
    });
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }

  if (data.resource_types && data.resource_types.length > 0) {
    data.resource_types.map((item) => {
      callURL += "&resource_types=" + item;
    });
  }
  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }
  if ('application_service_ids' in data && data.application_service_ids.length > 0) {
    data.application_service_ids.map((item) => {
      callURL += "&application_service_ids=" + item;
    });
  } else if ('opsgenie_team_ids' in data && data.opsgenie_team_ids.length > 0) {
    data.opsgenie_team_ids.map((item) => {
      callURL += "&opsgenie_team_ids=" + item;
    })
  } else if ('pagerduty_service_ids' in data && data.pagerduty_service_ids.length > 0) {
    data.pagerduty_service_ids.map((item) => {
      callURL += "&pagerduty_service_ids=" + item;
    });
  }

  if ('parent_resource_id' in data && data.parent_resource_id) {
    callURL += "&parent_resource_id=" + data.parent_resource_id;
  }
  return get(callURL);
};

export const getAppDynamicsAllExternalServicesURL = (data) => {
  let callURL = url.BASE_URL + "/app-dynamics/all-remote-service-alerts-paginated?"
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.environments && data.environments.length > 0) {
    data.environments.map((item) => {
      callURL += "&environments=" + item;
    });
  }
  if (data.health_filter && data.health_filter.length > 0) {
    data.health_filter.map((item) => {
      callURL += "&health_filter=" + item;
    });
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }

  if (data.resource_types && data.resource_types.length > 0) {
    data.resource_types.map((item) => {
      callURL += "&resource_types=" + item;
    });
  }
  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }
  if ('application_service_ids' in data && data.application_service_ids.length > 0) {
    data.application_service_ids.map((item) => {
      callURL += "&application_service_ids=" + item;
    });
  } else if ('opsgenie_team_ids' in data && data.opsgenie_team_ids.length > 0) {
    data.opsgenie_team_ids.map((item) => {
      callURL += "&opsgenie_team_ids=" + item;
    })
  } else if ('pagerduty_service_ids' in data && data.pagerduty_service_ids.length > 0) {
    data.pagerduty_service_ids.map((item) => {
      callURL += "&pagerduty_service_ids=" + item;
    });
  }

  if ('parent_resource_id' in data && data.parent_resource_id) {
    callURL += "&parent_resource_id=" + data.parent_resource_id;
  }

  return get(callURL);
};

export const postAppDynamicsServiceMappingUrl = data => post(url.BASE_URL + "/app-dynamics/map-resources-to-service", data);

export const postAppDynamicsResourceOpsgenieTeamMappingUrl = (data) => post(url.BASE_URL + "/app-dynamics/map-resources-to-opsgenie-team", data);

export const postAppDynamicsResourcePagerdutyServiceMappingUrl = (data) => post(url.BASE_URL + "/app-dynamics/map-resources-to-pagerduty-service", data);

//resource mapping
export const getResourceMappingConfigUrl = () => get(url.BASE_URL + "/resource-mapping-config");

export const postResourceMappingConfigUrl = (data) => post(url.BASE_URL + "/resource-mapping-configurations", data);

export const deleteResourceMappingConfigUrl = (data) => post(url.BASE_URL + "/delete-resource-mapping-config", data);

export const updateResourceMappingConfigUrl = (data) => post(url.BASE_URL + "/update-resource-mapping-config", data);

export const getAllAwsAccountsUrl = () => get(url.BASE_URL + "/aws-accounts");

export const getAllNewRelicAccountsUrl = () => get(url.BASE_URL + "/newrelic-accounts");

export const deleteAwsAccountUrl = (data) => post(url.BASE_URL + "/delete-aws-account", data);

export const deleteNewRelicAccountUrl = (data) => post(url.BASE_URL + "/delete-newrelic-account", data);

export const getEncryptedOrgIdUrl = () => get(url.BASE_URL + "/encrypted-org-id");

//Dynatrace
export const postDynatraceOnboardingURL = data => post(url.BASE_URL + "/dynatrace/onboarding", data);

export const getPingMonitorsUrl = () => get(url.BASE_URL + "/ping-monitoring/get-endpoints");

export const getUptimeCheckFailures = (data) => {
  let callURL = url.BASE_URL + `/ping-monitoring/uptime-check-failures?endpoint_id=${data.endpoint_id}`
  if (data.page) {
    callURL += "&page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  return get(callURL);
}

export const getPingMonitorDetailUrl = (endpoint_id) => get(url.BASE_URL + "/ping-monitoring/endpoint-by-id?endpoint_id="+endpoint_id);

export const postPingMonitorsUrl = (data) => post(url.BASE_URL + "/ping-monitoring/add-endpoint", data);

export const patchPingMonitorsUrl = (data) => put(url.BASE_URL + "/ping-monitoring/edit-endpoint", data);

export const mapEndpointToServiceUrl = (data) => post(url.BASE_URL + "/ping-monitoring/map-monitored-endpoint-to-service", data);

export const getEndpointByServiceIdUrl = (data) => post(url.BASE_URL + "/ping-monitoring/endpoints-on-application-service" , data);

export const getTimestampsUrl = (data) => get(url.BASE_URL + "/ping-monitoring/get-timestamps?endpoint_id=" + data.endpoint_id + '&duration_in_minutes=' + parseInt(data.duration_in_minutes, 10));

export const deleteEndpointUrl = (data) => post(url.BASE_URL+"/ping-monitoring/delete-endpoint", data)

export const toggleEndpointUrl = (data) => post(url.BASE_URL+"/ping-monitoring/enable-disable-endpoint", data)

export const validateRegexUrl = (data) => post(url.BASE_URL + "/ping-monitoring/validate-regex", data);

export const getTimestampsByServiceIdUrl = (data) => post(url.BASE_URL + "/ping-monitoring/timestamps-by-service-id", data); 

export const getDynatraceAllResourceAlertsPageUrl = (data) => {
  let callURL = url.BASE_URL + "/dynatrace/all-resource-alerts-paginated?"
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.environments && data.environments.length > 0) {
    data.environments.map((item) => {
      callURL += "&environments=" + item;
    });
  }
  if (data.health_filter && data.health_filter.length > 0) {
    data.health_filter.map((item) => {
      callURL += "&health_filter=" + item;
    });
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }
  if (data.region && data.region.length > 0) {
    callURL += "&region=" + data.region;
  }

  if (data.resource_types && data.resource_types.length > 0) {
    data.resource_types.map((item) => {
      callURL += "&resource_types=" + item;
    });
  }
  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }
  if ('application_service_ids' in data && data.application_service_ids.length > 0) {
    data.application_service_ids.map((item) => {
      callURL += "&application_service_ids=" + item;
    });
  } else if ('opsgenie_team_ids' in data && data.opsgenie_team_ids.length > 0) {
    data.opsgenie_team_ids.map((item) => {
      callURL += "&opsgenie_team_ids=" + item;
    })
  } else if ('pagerduty_service_ids' in data && data.pagerduty_service_ids.length > 0) {
    data.pagerduty_service_ids.map((item) => {
      callURL += "&pagerduty_service_ids=" + item;
    });
  }
  return get(callURL);
};

export const getDynatraceAllResourceAlertsCountPageUrl = (data) => {
  let callURL = url.BASE_URL + "/dynatrace/get-resource-count?"
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.environments && data.environments.length > 0) {
    data.environments.map((item) => {
      callURL += "&environments=" + item;
    });
  }
  if (data.health_filter && data.health_filter.length > 0) {
    data.health_filter.map((item) => {
      callURL += "&health_filter=" + item;
    });
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }
  if (data.region && data.region.length > 0) {
    callURL += "&region=" + data.region;
  }

  if (data.resource_types && data.resource_types.length > 0) {
    data.resource_types.map((item) => {
      callURL += "&resource_types=" + item;
    });
  }
  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }
  if ('application_service_ids' in data && data.application_service_ids.length > 0) {
    data.application_service_ids.map((item) => {
      callURL += "&application_service_ids=" + item;
    });
  } else if ('opsgenie_team_ids' in data && data.opsgenie_team_ids.length > 0) {
    data.opsgenie_team_ids.map((item) => {
      callURL += "&opsgenie_team_ids=" + item;
    })
  } else if ('pagerduty_service_ids' in data && data.pagerduty_service_ids.length > 0) {
    data.pagerduty_service_ids.map((item) => {
      callURL += "&pagerduty_service_ids=" + item;
    });
  }
  return get(callURL);
};

export const getDynatraceResourceTypesUrl = () => get(url.BASE_URL + "/dynatrace/resource-types");

export const postDynatraceServiceMappingUrl = data => post(url.BASE_URL + "/dynatrace/map-resources-to-service", data);

export const postDynatraceResourceOpsgenieTeamMappingUrl = (data) => post(url.BASE_URL + "/dynatrace/map-resources-to-opsgenie-team", data);

export const postDynatraceResourcePagerdutyServiceMappingUrl = (data) => post(url.BASE_URL + "/dynatrace/map-resources-to-pagerduty-service", data);

export const postDynatraceCreateResourceAlertsUrl = (data) => post(url.BASE_URL + "/dynatrace/create-resource-alerts", data);

export const getRescanStatusDynatraceUrl = data => get(url.BASE_URL + "/dynatrace/user-scan-status", data);

export const getDynatraceMissingAlertByResourceIDUrl = monitored_resource_id => get(url.BASE_URL + "/dynatrace/missing-alert-by-resource-id?monitored_resource_id=" + monitored_resource_id);

export const postDynatraceEnableDisableAlertsUrl = (data) => post(url.BASE_URL + "/dynatrace/enable-disable-alert-id", data);

export const getDynatraceResourceByIDUrl = data => get(url.BASE_URL + "/dynatrace/resource-by-id?monitored_resource_id=" + data);

export const getThresholdsDynatraceResourceByIDUrl = monitored_resource_id => get(url.BASE_URL + "/dynatrace/default-threshold-by-monitored-resource?monitored_resource_id=" + monitored_resource_id);

export const getMissingAlertsByResourceIDUrl = monitored_resource_id => get(url.BASE_URL + "/dynatrace/missing-alert-by-resource-id?monitored_resource_id=" + monitored_resource_id);

export const postDynatraceAlertUrl = data => put(url.BASE_URL + "/dynatrace/alert", data);

export const getDynatraceAlertByResourceIdUrl = monitored_resource_id => get(url.BASE_URL + "/dynatrace/alert?monitored_resource_id=" + monitored_resource_id);

export const getDynatraceRefreshUrl = () => get(url.BASE_URL + "/dynatrace/refresh");

export const getDynatraceThresholdUrl = () => get(url.BASE_URL + "/dynatrace/default-threshold-existing-resources");

export const getDynatraceResourcesUrl = () => get(url.BASE_URL + "/dynatrace/resource");

export const postEnableDisableDynatraceThresholdUrl = data => post(url.BASE_URL + "/dynatrace/enable-disable-default-threshold", data);

export const postUpdateDynatraceThresholdUrl = data => put(url.BASE_URL + "/dynatrace/default-threshold", data);

export const getDynatraceAllKeyUserActionPageUrl = (data) => {
  let callURL = url.BASE_URL + "/dynatrace/all-key-user-actions-paginated?"
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.environments && data.environments.length > 0) {
    data.environments.map((item) => {
      callURL += "&environments=" + item;
    });
  }
  if (data.health_filter && data.health_filter.length > 0) {
    data.health_filter.map((item) => {
      callURL += "&health_filter=" + item;
    });
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }
  if (data.region && data.region.length > 0) {
    callURL += "&region=" + data.region;
  }

  if (data.resource_types && data.resource_types.length > 0) {
    data.resource_types.map((item) => {
      callURL += "&resource_types=" + item;
    });
  }
  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }
  if(data.parent_resource_id) {
    callURL += "&parent_resource_id=" + data.parent_resource_id;
  }
  if ('application_service_ids' in data && data.application_service_ids.length > 0) {
    data.application_service_ids.map((item) => {
      callURL += "&application_service_ids=" + item;
    });
  } else if ('opsgenie_team_ids' in data && data.opsgenie_team_ids.length > 0) {
    data.opsgenie_team_ids.map((item) => {
      callURL += "&opsgenie_team_ids=" + item;
    })
  } else if ('pagerduty_service_ids' in data && data.pagerduty_service_ids.length > 0) {
    data.pagerduty_service_ids.map((item) => {
      callURL += "&pagerduty_service_ids=" + item;
    });

  }
  return get(callURL);
};

export const getDynatraceAllUserActionPageUrl = (data) => {
  let callURL = url.BASE_URL + "/dynatrace/all-user-actions-paginated?"
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.environments && data.environments.length > 0) {
    data.environments.map((item) => {
      callURL += "&environments=" + item;
    });
  }
  if (data.health_filter && data.health_filter.length > 0) {
    data.health_filter.map((item) => {
      callURL += "&health_filter=" + item;
    });
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }
  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }
  if(data.parent_resource_id) {
    callURL += "&parent_resource_id=" + data.parent_resource_id;
  }
  return get(callURL);
};


export const postCreateKeyUserActionUrl = data => post(url.BASE_URL + "/dynatrace/create-key-user-action", data);
// OCI

export const getOciAllResourceAlertsPageUrl = (data) => {
  let callURL = url.BASE_URL + "/oci/all-resource-alerts-paginated?"
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.environments && data.environments.length > 0) {
    data.environments.map((item) => {
      callURL += "&environments=" + item;
    });
  }
  if (data.health_filter && data.health_filter.length > 0) {
    data.health_filter.map((item) => {
      callURL += "&health_filter=" + item;
    });
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }
  if (data.region && data.region.length > 0) {
    callURL += "&region=" + data.region;
  }

  if (data.resource_types && data.resource_types.length > 0) {
    data.resource_types.map((item) => {
      callURL += "&resource_types=" + item;
    });
  }
  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }
  if ('application_service_ids' in data && data.application_service_ids.length > 0) {
    data.application_service_ids.map((item) => {
      callURL += "&application_service_ids=" + item;
    });
  } else if ('opsgenie_team_ids' in data && data.opsgenie_team_ids.length > 0) {
    data.opsgenie_team_ids.map((item) => {
      callURL += "&opsgenie_team_ids=" + item;
    })
  } else if ('pagerduty_service_ids' in data && data.pagerduty_service_ids.length > 0) {
    data.pagerduty_service_ids.map((item) => {
      callURL += "&pagerduty_service_ids=" + item;
    });
  }
  return get(callURL);
};

export const getOciAllResourceAlertsCountPageUrl = (data) => {
  let callURL = url.BASE_URL + "/oci/get-resource-count?"
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.environments && data.environments.length > 0) {
    data.environments.map((item) => {
      callURL += "&environments=" + item;
    });
  }
  if (data.health_filter && data.health_filter.length > 0) {
    data.health_filter.map((item) => {
      callURL += "&health_filter=" + item;
    });
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }
  if (data.region && data.region.length > 0) {
    callURL += "&region=" + data.region;
  }

  if (data.resource_types && data.resource_types.length > 0) {
    data.resource_types.map((item) => {
      callURL += "&resource_types=" + item;
    });
  }
  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }
  if ('application_service_ids' in data && data.application_service_ids.length > 0) {
    data.application_service_ids.map((item) => {
      callURL += "&application_service_ids=" + item;
    });
  } else if ('opsgenie_team_ids' in data && data.opsgenie_team_ids.length > 0) {
    data.opsgenie_team_ids.map((item) => {
      callURL += "&opsgenie_team_ids=" + item;
    })
  } else if ('pagerduty_service_ids' in data && data.pagerduty_service_ids.length > 0) {
    data.pagerduty_service_ids.map((item) => {
      callURL += "&pagerduty_service_ids=" + item;
    });
  }
  return get(callURL);
};

export const getOciResourceTypesUrl = () => get(url.BASE_URL + "/oci/resource-types");

export const postOciServiceMappingUrl = data => post(url.BASE_URL + "/oci/map-resources-to-service", data);

export const postOciResourceOpsgenieTeamMappingUrl = (data) => post(url.BASE_URL + "/oci/map-resources-to-opsgenie-team", data);

export const postOciResourcePagerdutyServiceMappingUrl = (data) => post(url.BASE_URL + "/oci/map-resources-to-pagerduty-service", data);

export const postOciCreateResourceAlertsUrl = (data) => post(url.BASE_URL + "/oci/create-resource-alerts", data);

export const getRescanStatusOciUrl = data => get(url.BASE_URL + "/oci/user-scan-status", data);

export const getOciMissingAlertByResourceIDUrl = monitored_resource_id => get(url.BASE_URL + "/oci/missing-alert-by-resource-id?monitored_resource_id=" + monitored_resource_id);

export const postOciEnableDisableAlertsUrl = (data) => post(url.BASE_URL + "/oci/enable-disable-alert-id", data);

export const getOciResourceByIDUrl = data => get(url.BASE_URL + "/oci/resource-by-id?monitored_resource_id=" + data);

export const getThresholdsOciResourceByIDUrl = monitored_resource_id => get(url.BASE_URL + "/oci/default-threshold-by-monitored-resource?monitored_resource_id=" + monitored_resource_id);

export const getOciMissingAlertsByResourceIDUrl = monitored_resource_id => get(url.BASE_URL + "/oci/missing-alert-by-resource-id?monitored_resource_id=" + monitored_resource_id);

export const postOciAlertUrl = data => put(url.BASE_URL + "/oci/alert", data);

export const getOciAlertByResourceIdUrl = monitored_resource_id => get(url.BASE_URL + "/oci/alert?monitored_resource_id=" + monitored_resource_id);

export const getOciRefreshUrl = () => get(url.BASE_URL + "/oci/refresh");

export const getOciThresholdUrl = () => get(url.BASE_URL + "/oci/default-threshold-existing-resources");

export const getOciResourcesUrl = () => get(url.BASE_URL + "/oci/resource");

export const postEnableDisableOciThresholdUrl = data => post(url.BASE_URL + "/oci/enable-disable-default-threshold", data);

export const postUpdateOciThresholdUrl = data => put(url.BASE_URL + "/oci/default-threshold", data);

//Grafana
export const getGrafanaThresholdUrl = () => get(url.BASE_URL + "/grafana/default-threshold-existing-resources");

export const postGrafanaOnboardingUrl = data => post(url.BASE_URL + "/grafana/onboarding", data);

export const getGrafanaResourcesUrl = () => get(url.BASE_URL + "/grafana/resource");

export const getAllOrgGrafanaResourceTypesUrl = () => get(url.BASE_URL + "/grafana/org-resource-types");

export const postUpdateGrafanaThresholdUrl = data => put(url.BASE_URL + "/grafana/default-threshold", data);

export const postGrafanaEnableDisableAlertsUrl = (data) => post(url.BASE_URL + "/grafana/enable-disable-alert-id", data);

export const postGrafanaCreateResourceAlertsUrl = (data) => post(url.BASE_URL + "/grafana/create-grafana-resource-alerts", data);

export const postGrafanaCreateDynamicAlertUrl = (data) => post(url.BASE_URL + "/grafana/create-dynamic-alert", data);

export const getGrafanaAlertUrl = monitored_resource_id => get(url.BASE_URL + "/grafana/alert?monitored_resource_id=" + monitored_resource_id);

export const getGrafanaDynamicAlertsUrl = monitored_resource_id => get(url.BASE_URL + "/grafana/get-dynamic-alerts?monitored_resource_id=" + monitored_resource_id);

export const getGrafanaMissingDynamicAlertsUrl = monitored_resource_id => get(url.BASE_URL + "/grafana/get-missing-dynamic-alerts?monitored_resource_id=" + monitored_resource_id);

export const getGrafanaDefaultThresholdUrl = threshold_type => get(url.BASE_URL + "/grafana/default-threshold?threshold_type=" + threshold_type);

export const getGrafanaResourceByIDUrl = data => get(url.BASE_URL + "/grafana/resource-by-id?monitored_resource_id=" + data);

export const getGrafanaResourceDefaultThresholdByIdUrl = monitored_resource_id => get(url.BASE_URL + "/grafana/default-threshold-by-monitored-resource?monitored_resource_id=" + monitored_resource_id);

export const postGrafanaAlertUrl = data => put(url.BASE_URL + "/grafana/alert", data);

export const getGrafanaRescanUrl = () => get(url.BASE_URL + "/grafana/refresh");

export const getGrafanaMissingAlertByResourceIdUrl = monitored_resource_id => get(url.BASE_URL + "/grafana/missing-alert-by-resource-id?monitored_resource_id=" + monitored_resource_id );

export const getGrafanaResourceByIdUrl = monitored_resource_id => get(url.BASE_URL + "/grafana/monitored_resource_id=" + monitored_resource_id)

export const postEnableDisableGrafanaThresholdUrl = data => post(url.BASE_URL + "/grafana/enable-disable-default-threshold", data);

export const postMarkNonKeyGrafanaTransactionAsBusinessTransactionUrl = data => post(url.BASE_URL + "/grafana/mark-grafana-non-key-transaction-to-business-transaction", data);

export const getRescanStatusGrafanaUrl = data => get(url.BASE_URL + "/grafana/user-scan-status", data);

export const getGrafanaAllResourceAlertsPageUrl = (data) => {
  let callURL = url.BASE_URL + "/grafana/all-resource-alerts-paginated?"
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.environments && data.environments.length > 0) {
    data.environments.map((item) => {
      callURL += "&environments=" + item;
    });
  }
  if (data.health_filter && data.health_filter.length > 0) {
    data.health_filter.map((item) => {
      callURL += "&health_filter=" + item;
    });
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }
  if (data.region && data.region.length > 0) {
    callURL += "&region=" + data.region;
  }

  if (data.resource_types && data.resource_types.length > 0) {
    data.resource_types.map((item) => {
      callURL += "&resource_types=" + item;
    });
  }
  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }
  if ('application_service_ids' in data && data.application_service_ids.length > 0) {
    data.application_service_ids.map((item) => {
      callURL += "&application_service_ids=" + item;
    });
  } else if ('opsgenie_team_ids' in data && data.opsgenie_team_ids.length > 0) {
    data.opsgenie_team_ids.map((item) => {
      callURL += "&opsgenie_team_ids=" + item;
    })
  } else if ('pagerduty_service_ids' in data && data.pagerduty_service_ids.length > 0) {
    data.pagerduty_service_ids.map((item) => {
      callURL += "&pagerduty_service_ids=" + item;
    });
  }
  return get(callURL);
};

export const getGrafanaAllResourceAlertsCountPageUrl = (data) => {
  let callURL = url.BASE_URL + "/grafana/get-resource-count?"
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.environments && data.environments.length > 0) {
    data.environments.map((item) => {
      callURL += "&environments=" + item;
    });
  }
  if (data.health_filter && data.health_filter.length > 0) {
    data.health_filter.map((item) => {
      callURL += "&health_filter=" + item;
    });
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }
  if (data.region && data.region.length > 0) {
    callURL += "&region=" + data.region;
  }

  if (data.resource_types && data.resource_types.length > 0) {
    data.resource_types.map((item) => {
      callURL += "&resource_types=" + item;
    });
  }
  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }
  if ('application_service_ids' in data && data.application_service_ids.length > 0) {
    data.application_service_ids.map((item) => {
      callURL += "&application_service_ids=" + item;
    });
  } else if ('opsgenie_team_ids' in data && data.opsgenie_team_ids.length > 0) {
    data.opsgenie_team_ids.map((item) => {
      callURL += "&opsgenie_team_ids=" + item;
    })
  } else if ('pagerduty_service_ids' in data && data.pagerduty_service_ids.length > 0) {
    data.pagerduty_service_ids.map((item) => {
      callURL += "&pagerduty_service_ids=" + item;
    });
  }
  return get(callURL);
};

export const getGrafanaNonKeyTransactionsByParentResourceUrl = (data) => {
  let callURL = url.BASE_URL + "/grafana/all-grafana-non-key-transactions-by-apm-paginated?";
  callURL += "parent_resource_id=" + data.parent_resource_id;
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.page) {
    callURL += "&page=" + data.page
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }
  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }

  return get(callURL);
}

export const getGrafanaAllBusinessTransactionAlertsUrl = (data) => {
  let callURL = url.BASE_URL + "/grafana/all-business-transaction-alerts-paginated?"
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.environments && data.environments.length > 0) {
    data.environments.map((item) => {
      callURL += "&environments=" + item;
    });
  }
  if (data.health_filter && data.health_filter.length > 0) {
    data.health_filter.map((item) => {
      callURL += "&health_filter=" + item;
    });
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }

  if (data.resource_types && data.resource_types.length > 0) {
    data.resource_types.map((item) => {
      callURL += "&resource_types=" + item;
    });
  }
  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }
  if ('application_service_ids' in data && data.application_service_ids.length > 0) {
    data.application_service_ids.map((item) => {
      callURL += "&application_service_ids=" + item;
    });
  } else if ('opsgenie_team_ids' in data && data.opsgenie_team_ids.length > 0) {
    data.opsgenie_team_ids.map((item) => {
      callURL += "&opsgenie_team_ids=" + item;
    })
  } else if ('pagerduty_service_ids' in data && data.pagerduty_service_ids.length > 0) {
    data.pagerduty_service_ids.map((item) => {
      callURL += "&pagerduty_service_ids=" + item;
    });
  }

  if ('parent_resource_id' in data && data.parent_resource_id) {
    callURL += "&parent_resource_id=" + data.parent_resource_id;
  }
  return get(callURL);
};

export const getGrafanaAllExternalServicesURL = (data) => {
  let callURL = url.BASE_URL + "/grafana/all-remote-service-alerts-paginated?"
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.environments && data.environments.length > 0) {
    data.environments.map((item) => {
      callURL += "&environments=" + item;
    });
  }
  if (data.health_filter && data.health_filter.length > 0) {
    data.health_filter.map((item) => {
      callURL += "&health_filter=" + item;
    });
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }

  if (data.resource_types && data.resource_types.length > 0) {
    data.resource_types.map((item) => {
      callURL += "&resource_types=" + item;
    });
  }
  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }
  if ('application_service_ids' in data && data.application_service_ids.length > 0) {
    data.application_service_ids.map((item) => {
      callURL += "&application_service_ids=" + item;
    });
  } else if ('opsgenie_team_ids' in data && data.opsgenie_team_ids.length > 0) {
    data.opsgenie_team_ids.map((item) => {
      callURL += "&opsgenie_team_ids=" + item;
    })
  } else if ('pagerduty_service_ids' in data && data.pagerduty_service_ids.length > 0) {
    data.pagerduty_service_ids.map((item) => {
      callURL += "&pagerduty_service_ids=" + item;
    });
  }

  if ('parent_resource_id' in data && data.parent_resource_id) {
    callURL += "&parent_resource_id=" + data.parent_resource_id;
  }

  return get(callURL);
};

export const postGrafanaServiceMappingUrl = data => post(url.BASE_URL + "/grafana/map-resources-to-service", data);

export const postGrafanaResourceOpsgenieTeamMappingUrl = (data) => post(url.BASE_URL + "/grafana/map-resources-to-opsgenie-team", data);

export const postGrafanaResourcePagerdutyServiceMappingUrl = (data) => post(url.BASE_URL + "/grafana/map-resources-to-pagerduty-service", data);

//Signoz
export const getSignozThresholdUrl = () => get(url.BASE_URL + "/signoz/default-threshold-existing-resources");

export const postSignozOnboardingUrl = data => post(url.BASE_URL + "/signoz/onboarding", data);

export const getSignozResourcesUrl = () => get(url.BASE_URL + "/signoz/resource");

export const getAllOrgSignozResourceTypesUrl = () => get(url.BASE_URL + "/signoz/org-resource-types");

export const postUpdateSignozThresholdUrl = data => put(url.BASE_URL + "/signoz/default-threshold", data);

export const postSignozEnableDisableAlertsUrl = (data) => post(url.BASE_URL + "/signoz/enable-disable-alert-id", data);

export const postSignozCreateResourceAlertsUrl = (data) => post(url.BASE_URL + "/signoz/create-signoz-resource-alerts", data);

export const postSignozCreateDynamicAlertUrl = (data) => post(url.BASE_URL + "/signoz/create-dynamic-alert", data);

export const getSignozAlertUrl = monitored_resource_id => get(url.BASE_URL + "/signoz/alert?monitored_resource_id=" + monitored_resource_id);

export const getSignozDynamicAlertsUrl = monitored_resource_id => get(url.BASE_URL + "/signoz/get-dynamic-alerts?monitored_resource_id=" + monitored_resource_id);

export const getSignozMissingDynamicAlertsUrl = monitored_resource_id => get(url.BASE_URL + "/signoz/get-missing-dynamic-alerts?monitored_resource_id=" + monitored_resource_id);

export const getSignozDefaultThresholdUrl = threshold_type => get(url.BASE_URL + "/signoz/default-threshold?threshold_type=" + threshold_type);

export const getSignozResourceByIDUrl = data => get(url.BASE_URL + "/signoz/resource-by-id?monitored_resource_id=" + data);

export const getSignozResourceDefaultThresholdByIdUrl = monitored_resource_id => get(url.BASE_URL + "/signoz/default-threshold-by-monitored-resource?monitored_resource_id=" + monitored_resource_id);

export const postSignozAlertUrl = data => put(url.BASE_URL + "/signoz/alert", data);

export const getSignozRescanUrl = () => get(url.BASE_URL + "/signoz/refresh");

export const getSignozMissingAlertByResourceIdUrl = monitored_resource_id => get(url.BASE_URL + "/signoz/missing-alert-by-resource-id?monitored_resource_id=" + monitored_resource_id );

export const getSignozResourceByIdUrl = monitored_resource_id => get(url.BASE_URL + "/signoz/monitored_resource_id=" + monitored_resource_id)

export const postEnableDisableSignozThresholdUrl = data => post(url.BASE_URL + "/signoz/enable-disable-default-threshold", data);

export const postMarkNonKeySignozTransactionAsBusinessTransactionUrl = data => post(url.BASE_URL + "/signoz/mark-signoz-non-key-transaction-to-business-transaction", data);

export const getRescanStatusSignozUrl = data => get(url.BASE_URL + "/signoz/user-scan-status", data);

export const getSignozAllResourceAlertsPageUrl = (data) => {
  let callURL = url.BASE_URL + "/signoz/all-resource-alerts-paginated?"
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.environments && data.environments.length > 0) {
    data.environments.map((item) => {
      callURL += "&environments=" + item;
    });
  }
  if (data.health_filter && data.health_filter.length > 0) {
    data.health_filter.map((item) => {
      callURL += "&health_filter=" + item;
    });
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }
  if (data.region && data.region.length > 0) {
    callURL += "&region=" + data.region;
  }

  if (data.resource_types && data.resource_types.length > 0) {
    data.resource_types.map((item) => {
      callURL += "&resource_types=" + item;
    });
  }
  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }
  if ('application_service_ids' in data && data.application_service_ids.length > 0) {
    data.application_service_ids.map((item) => {
      callURL += "&application_service_ids=" + item;
    });
  } else if ('opsgenie_team_ids' in data && data.opsgenie_team_ids.length > 0) {
    data.opsgenie_team_ids.map((item) => {
      callURL += "&opsgenie_team_ids=" + item;
    })
  } else if ('pagerduty_service_ids' in data && data.pagerduty_service_ids.length > 0) {
    data.pagerduty_service_ids.map((item) => {
      callURL += "&pagerduty_service_ids=" + item;
    });
  }
  return get(callURL);
};

export const getSignozAllResourceAlertsCountPageUrl = (data) => {
  let callURL = url.BASE_URL + "/signoz/get-resource-count?"
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.environments && data.environments.length > 0) {
    data.environments.map((item) => {
      callURL += "&environments=" + item;
    });
  }
  if (data.health_filter && data.health_filter.length > 0) {
    data.health_filter.map((item) => {
      callURL += "&health_filter=" + item;
    });
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }
  if (data.region && data.region.length > 0) {
    callURL += "&region=" + data.region;
  }

  if (data.resource_types && data.resource_types.length > 0) {
    data.resource_types.map((item) => {
      callURL += "&resource_types=" + item;
    });
  }
  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }
  if ('application_service_ids' in data && data.application_service_ids.length > 0) {
    data.application_service_ids.map((item) => {
      callURL += "&application_service_ids=" + item;
    });
  } else if ('opsgenie_team_ids' in data && data.opsgenie_team_ids.length > 0) {
    data.opsgenie_team_ids.map((item) => {
      callURL += "&opsgenie_team_ids=" + item;
    })
  } else if ('pagerduty_service_ids' in data && data.pagerduty_service_ids.length > 0) {
    data.pagerduty_service_ids.map((item) => {
      callURL += "&pagerduty_service_ids=" + item;
    });
  }
  return get(callURL);
};

export const getSignozNonKeyTransactionsByParentResourceUrl = (data) => {
  let callURL = url.BASE_URL + "/signoz/all-signoz-non-key-transactions-by-apm-paginated?";
  callURL += "parent_resource_id=" + data.parent_resource_id;
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.page) {
    callURL += "&page=" + data.page
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }
  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }

  return get(callURL);
}

export const getSignozAllBusinessTransactionAlertsUrl = (data) => {
  let callURL = url.BASE_URL + "/signoz/all-business-transaction-alerts-paginated?"
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.environments && data.environments.length > 0) {
    data.environments.map((item) => {
      callURL += "&environments=" + item;
    });
  }
  if (data.health_filter && data.health_filter.length > 0) {
    data.health_filter.map((item) => {
      callURL += "&health_filter=" + item;
    });
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }

  if (data.resource_types && data.resource_types.length > 0) {
    data.resource_types.map((item) => {
      callURL += "&resource_types=" + item;
    });
  }
  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }
  if ('application_service_ids' in data && data.application_service_ids.length > 0) {
    data.application_service_ids.map((item) => {
      callURL += "&application_service_ids=" + item;
    });
  } else if ('opsgenie_team_ids' in data && data.opsgenie_team_ids.length > 0) {
    data.opsgenie_team_ids.map((item) => {
      callURL += "&opsgenie_team_ids=" + item;
    })
  } else if ('pagerduty_service_ids' in data && data.pagerduty_service_ids.length > 0) {
    data.pagerduty_service_ids.map((item) => {
      callURL += "&pagerduty_service_ids=" + item;
    });
  }

  if ('parent_resource_id' in data && data.parent_resource_id) {
    callURL += "&parent_resource_id=" + data.parent_resource_id;
  }
  return get(callURL);
};

export const getSignozAllExternalServicesURL = (data) => {
  let callURL = url.BASE_URL + "/signoz/all-remote-service-alerts-paginated?"
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.environments && data.environments.length > 0) {
    data.environments.map((item) => {
      callURL += "&environments=" + item;
    });
  }
  if (data.health_filter && data.health_filter.length > 0) {
    data.health_filter.map((item) => {
      callURL += "&health_filter=" + item;
    });
  }
  if (data.search_item && data.search_item.length > 0) {
    callURL += "&search_item=" + data.search_item;
  }

  if (data.resource_types && data.resource_types.length > 0) {
    data.resource_types.map((item) => {
      callURL += "&resource_types=" + item;
    });
  }
  if (data.start_date) {
    callURL += "&start_date=" + data.start_date;
  }
  if (data.end_date) {
    callURL += "&end_date=" + data.end_date;
  }
  if ('application_service_ids' in data && data.application_service_ids.length > 0) {
    data.application_service_ids.map((item) => {
      callURL += "&application_service_ids=" + item;
    });
  } else if ('opsgenie_team_ids' in data && data.opsgenie_team_ids.length > 0) {
    data.opsgenie_team_ids.map((item) => {
      callURL += "&opsgenie_team_ids=" + item;
    })
  } else if ('pagerduty_service_ids' in data && data.pagerduty_service_ids.length > 0) {
    data.pagerduty_service_ids.map((item) => {
      callURL += "&pagerduty_service_ids=" + item;
    });
  }

  if ('parent_resource_id' in data && data.parent_resource_id) {
    callURL += "&parent_resource_id=" + data.parent_resource_id;
  }

  return get(callURL);
};

export const postSignozServiceMappingUrl = data => post(url.BASE_URL + "/signoz/map-resources-to-service", data);


export const createDaemonUrl = data => post(url.BASE_URL + "/daemon-manager/create", data);

export const refreshNewDaemonUrl = data => post(url.BASE_URL + "/daemon-manager/refresh-daemon-token", data);

export const getDaemonUrl = () => get(url.BASE_URL + "/daemon-manager/all-daemons");

export const getAllTokensUrl = () => get(url.BASE_URL + "/daemon-manager/all-tokens");

export const getExecuteResultsUrl = (data) => get(url.BASE_URL + `/daemon-manager/get-requests/${data}`);

export const getLambdasUrl = () => get(url.BASE_URL + "/daemon-manager/lambdas");

export const getAccountLambdasUrl = (data) => get(url.BASE_URL + `/daemon-manager/lambdas?monitoring_system_id=${data}`);

export const deployLambdaUrl = data => post(url.BASE_URL + "/daemon-manager/deploy-lambda", data);

export const deployLambdaDetailsUrl = data => post(url.BASE_URL + "/daemon-manager/receive-lambda-arns-from-user", data);

export const addOrEditRunbookScriptUrl = data => post(url.BASE_URL + "/daemon-manager/runbook-scripts", data);

export const getAlertsBasedOnResourceUrl = data => {
    let callURL = url.BASE_URL + `/daemon-manager/alerts?`
    if (data.page) {
      callURL += "page=" + data.page;
    }
    if (data.limit) {
      callURL += "&per_page=" + data.limit;
    }
    if (data.master_resource_id) {
      callURL += "&master_resource_id=" + data.master_resource_id;
    }
    if (data.monitoring_system_id) {
      callURL += "&monitoring_system_id=" + data.monitoring_system_id;
    }
    return get(callURL);
}

export const postMapAlertToDeployedLambdaUrl = data => post(url.BASE_URL + "/daemon-manager/lambda-alert-map", data);

export const postDisassociateAlertFromLambdaUrl = data => post(url.BASE_URL + "/daemon-manager/disassociate-lambda-alert", data);

export const getMappedLambdaAlertsUrl = data => {
  let callURL = url.BASE_URL + `/daemon-manager/mapped-lambda-alerts`
  if (data.master_resource_id){
    callURL += "?master_resource_id=" + data.master_resource_id;
  }
    if (data.monitoring_system_id) {
      callURL += "&monitoring_system_id=" + data.monitoring_system_id;
    }
    return get(callURL);
}
;

export const getAvailableRolesUrl = () => get(url.BASE_URL + "/daemon-manager/available-roles");

export const getDaemonDetailUrl = data => get(url.BASE_URL + `/daemon-manager/daemon-detail?daemon_id=${data}`);

export const updateDaemonTokenUrl = data => put(url.BASE_URL + "/daemon-manager/token", data);

export const getRunbookScripts = () => get(url.BASE_URL + "/daemon-manager/runbook-scripts");

export const deployRunbookScript = data => post(url.BASE_URL + "/daemon-manager/deploy-user-script", data);

// postForgetPwd
const postJwtForgetPwd = data => post(url.POST_FAKE_JWT_PASSWORD_FORGET, data);

// postSocialLogin
export const postSocialLogin = data => post(url.SOCIAL_LOGIN, data);

// get Products
export const getProducts = () => get(url.GET_PRODUCTS);

// get Product detail
export const getProductDetail = id =>
  get(`${url.GET_PRODUCTS_DETAIL}/${id}`, { params: { id } });

// get Events
export const getEvents = () => get(url.GET_EVENTS);

// add Events
export const addNewEvent = event => post(url.ADD_NEW_EVENT, event);

// update Event
export const updateEvent = event => put(url.UPDATE_EVENT, event);

// delete Event
export const deleteEvent = event =>
  del(url.DELETE_EVENT, { headers: { event } });

// get Categories
export const getCategories = () => get(url.GET_CATEGORIES);

// get chats
export const getChats = () => get(url.GET_CHATS);

// get groups
export const getGroups = () => get(url.GET_GROUPS);

// get Contacts
export const getContacts = () => get(url.GET_CONTACTS);

// get messages
export const getMessages = (roomId = "") =>
  get(`${url.GET_MESSAGES}/${roomId}`, { params: { roomId } });

// post messages
export const getselectedmails = (selectedmails) => post(url.GET_SELECTED_MAILS, selectedmails);

//post setfolderonmails
export const setfolderonmails = (selectedmails, folderId, activeTab) => post(url.SET_FOLDER_SELECTED_MAILS, { selectedmails, folderId, activeTab });

// get orders
export const getOrders = () => get(url.GET_ORDERS);

// add order
export const addNewOrder = order => post(url.ADD_NEW_ORDER, order);

// update order
export const updateOrder = order => put(url.UPDATE_ORDER, order);

// delete order
export const deleteOrder = order =>
  del(url.DELETE_ORDER, { headers: { order } });

// get cart data
export const getCartData = () => get(url.GET_CART_DATA);

// get customers
export const getCustomers = () => get(url.GET_CUSTOMERS);

// add CUSTOMER
export const addNewCustomer = customer => post(url.ADD_NEW_CUSTOMER, customer);

// update CUSTOMER
export const updateCustomer = customer => put(url.UPDATE_CUSTOMER, customer);

// delete CUSTOMER
export const deleteCustomer = customer =>
  del(url.DELETE_CUSTOMER, { headers: { customer } });

// get shops
export const getShops = () => get(url.GET_SHOPS);

// get wallet
export const getWallet = () => get(url.GET_WALLET);

// get crypto order
export const getCryptoOrder = () => get(url.GET_CRYPTO_ORDERS);

// get crypto product
export const getCryptoProduct = () => get(url.GET_CRYPTO_PRODUCTS);

// get invoices
export const getInvoices = () => get(url.GET_INVOICES);

// get invoice details
export const getInvoiceDetail = id =>
  get(`${url.GET_INVOICE_DETAIL}/${id}`, { params: { id } });

// get jobs
export const getJobList = () => get(url.GET_JOB_LIST);

// get Apply Jobs
export const getApplyJob = () => get(url.GET_APPLY_JOB);

// get project
export const getProjects = () => get(url.GET_PROJECTS);

// get project details
export const getProjectsDetails = id =>
  get(`${url.GET_PROJECT_DETAIL}/${id}`, { params: { id } });

// get tasks
export const getTasks = () => get(url.GET_TASKS);

// get contacts

// add user
export const addNewUser = user => post(url.ADD_NEW_USER, user);

// update user
export const updateUser = user => put(url.UPDATE_USER, user);

// delete user
export const deleteUser = user => del(url.DELETE_USER, { headers: { user } });

// add jobs
export const addNewJobList = job => post(url.ADD_NEW_JOB_LIST, job);

// update jobs
export const updateJobList = job => put(url.UPDATE_JOB_LIST, job);

// delete jobs
export const deleteJobList = job => del(url.DELETE_JOB_LIST, { headers: { job } });

// Delete Apply Jobs
export const deleteApplyJob = data => del(url.DELETE_APPLY_JOB, { headers: { data } });

/** PROJECT */
// add user
export const addNewProject = project => post(url.ADD_NEW_PROJECT, project);

// update user
export const updateProject = project => put(url.UPDATE_PROJECT, project);

// delete user
export const deleteProject = project =>
  del(url.DELETE_PROJECT, { headers: { project } });

export const getUserProfile = () => get(url.BASE_URL + url.GET_USER_PROFILE);

//update password
export const updatePassword = (data) => post(url.BASE_URL + url.UPDATE_PASSWORD, data);

//update Phone Number
export const UpdatePhoneNumber = (data) => post(url.BASE_URL + url.UPDATE_PHONE_NUMBER, data);

export const UpdateUserDetails = (data) => post(url.BASE_URL + url.UPDATE_DETAILS, data);

// get maillist
export const getMailsLists = filter => post(url.GET_MAILS_LIST, {
  params: filter,
});

//update mail
export const updateMail = mail => put(url.UPDATE_MAIL, mail);

// get folderlist
export const selectFolders = () => get(url.SELECT_FOLDER);

// post messages
export const addMessage = message => post(url.ADD_MESSAGE, message);

// get dashboard charts data
export const getWeeklyData = () => get(url.GET_WEEKLY_DATA);
export const getYearlyData = () => get(url.GET_YEARLY_DATA);
export const getMonthlyData = () => get(url.GET_MONTHLY_DATA);

export const walletBalanceData = month =>
  get(`${url.GET_WALLET_DATA}/${month}`, { params: { month } });

export const getStatisticData = duration =>
  get(`${url.GET_STATISTICS_DATA}/${duration}`, { params: { duration } });

export const visitorData = duration =>
  get(`${url.GET_VISITOR_DATA}/${duration}`, { params: { duration } });

export const topSellingData = month =>
  get(`${url.TOP_SELLING_DATA}/${month}`, { params: { month } });

export const getEarningChartsData = month =>
  get(`${url.GET_EARNING_DATA}/${month}`, { params: { month } });

const getProductComents = () => get(url.GET_PRODUCT_COMMENTS);

const onLikeComment = (commentId, productId) => {
  return post(`${url.ON_LIKNE_COMMENT}/${productId}/${commentId}`, {
    params: { commentId, productId },
  });
};
const onLikeReply = (commentId, productId, replyId) => {
  return post(`${url.ON_LIKNE_COMMENT}/${productId}/${commentId}/${replyId}`, {
    params: { commentId, productId, replyId },
  });
};

const onAddReply = (commentId, productId, replyText) => {
  return post(`${url.ON_ADD_REPLY}/${productId}/${commentId}`, {
    params: { commentId, productId, replyText },
  });
};

const onAddComment = (productId, commentText) => {
  return post(`${url.ON_ADD_COMMENT}/${productId}`, {
    params: { productId, commentText },
  });
};

//status page
export const getIncidentsUrl = () => get(url.BASE_URL + "/statuspage/incidents");
export const getIncidentsPublicPageUrl = () => get(url.BASE_URL + "/statuspage/incidents-public-page");
export const postCreateIncident = data => post(url.BASE_URL + "/statuspage/incidents", data);
export const getIncidentByIdUrl = (incident_id) =>
  get(url.BASE_URL + `/statuspage/incidents/${incident_id}`);

export const getStatusPageState = () => get(url.BASE_URL + "/statuspage/status-page-details");

export const updateIncidentUrl = data =>
  put(url.BASE_URL + `/statuspage/incidents/${data.incident_id}`, data);

export const getTimestampData = (data) => post(url.BASE_URL + "/statuspage/get-timestamps", data);

export const getTimeStampDataForOneDay = (data) => post(url.BASE_URL + "/statuspage/get-timestamps", data);

export const getTimestampDataPublicPage = (data) => post(url.BASE_URL + "/statuspage/get-timestamps-public-page", data);

export const getTimeStampDataForOneDayPublicPageUrl = (data) => post(url.BASE_URL + "/statuspage/get-timestamps-public-page", data);

export const getUptimeCheckDetailsURL = () => get(url.BASE_URL + "/ping-monitoring/get-endpoint-details");

export const deleteComponentServiceUrl = data => post(url.BASE_URL + "/statuspage/delete-component", data);

export const deleteIncidentUrl = data => post(url.BASE_URL + "/statuspage/delete-incident", data);

export const createComponentService = data => post(url.BASE_URL + "/statuspage/components", data);

export const getComponentService = () => get(url.BASE_URL + "/statuspage/components");

export const getComponentServicePublicPageUrl = () => get(url.BASE_URL + "/statuspage/components-public-page");

export const verifyRecaptchaToken = token => post(url.BASE_URL + "/statuspage/verify-recaptcha", { token });

export const subscribeToStatusPage = data => post(url.BASE_URL + "/statuspage/subscribe", data);

export const statuspageEmailConfirmation = (token) => get(url.BASE_URL + `/statuspage/confirm-subscription/${token}`);

export const getExternalComponents = () => get(url.BASE_URL + "/integration/master-statuspage-cloud-services");

export const getAWSHealthEvents = () => get(url.BASE_URL + "/integration/aws-health-events");

export const getAllResourcesUrl = (data) => {
  let callURL = url.BASE_URL + "/statuspage/all-resources-paginated?"
  if (data.page) {
    callURL += "page=" + data.page;
  }
  if (data.limit) {
    callURL += "&per_page=" + data.limit;
  }
  if (data.monitoring_system) {
    callURL += "&monitoring_system=" + data.monitoring_system;
  }
  if (data.master_resource_id) {
    callURL += "&master_resource_id=" + data.master_resource_id;
  }
  if (data.application_service_id){
    callURL += "&application_service_id=" + data.application_service_id;
  }
  if (data.search_item) {
    callURL += "&search_item=" + data.search_item;
  }
  return get(callURL);
};

export const getResourcesCountUrl = (data) => {
  let callURL = url.BASE_URL + "/statuspage/get_resources_count?";
  if (data.monitoring_system) {
    callURL += "monitoring_system=" + data.monitoring_system;
  }
  if (data.master_resource_id) {
    callURL += "&master_resource_id=" + data.master_resource_id;
  }
  if (data.application_service_id){
    callURL += "&application_service_id=" + data.application_service_id;
  }
  if (data.search_item) {
    callURL += "&search_item=" + data.search_item;
  }
  return get(callURL);
};

export const mapAlertsToComponentServiceUrl = data => post(url.BASE_URL + "/statuspage/map-alerts-to-component-service", data);

export const getMappedAlertsUrl = () => get(url.BASE_URL + "/statuspage/mapped-alerts");

export const disassociateAlertToComponentService = data => post(url.BASE_URL + "/statuspage/disassociate-alerts", data);

export {
  getLoggedInUser,
  isUserAuthenticated,
  postFakeRegister,
  postFakeLogin,
  postFakeProfile,
  postFakeForgetPwd,
  postJwtRegister,
  postJwtLogin,
  postJwtForgetPwd,
  postJwtProfile,
  getProductComents,
  onLikeComment,
  onLikeReply,
  onAddReply,
  onAddComment,
};